
import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useFourThreeThreeBApi } from '../../resources/hooks/api/fourThreeThreeBApiHook';
import Select from 'react-select';
import toast from 'react-hot-toast';
import "react-datepicker/dist/react-datepicker.css";
import { MONTHS, STATES } from '../../resources/constants';
import { calculateMaxHeightContent, lastYears } from '../../resources/functions';
import Form from 'react-bootstrap/Form';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm, Controller, useFieldArray } from "react-hook-form";
import { CreateFourThreeThreeFormI, PersonalBalanceFormI } from '../../resources/form-props';
import { PersonalBalanceValidate } from '../../resources/form-validator'
import Spinner from 'react-bootstrap/Spinner';
import filterSolidIcon from '../../assets/images/filter-solid-icon.svg';
import DatePicker from "react-datepicker";
import moment from 'moment'
import html2canvas from 'html2canvas';
import { jsPDF } from 'jspdf';
import html2pdf from 'html2pdf.js';
import { useTranslation } from 'react-i18next'; 

import { getBranch } from '../../store/user/selectors'

interface Props {

}

const PersonalBalanceSheet: React.FC<Props> = () => {
    const { t } = useTranslation("scenes.PersonalBalanceSheet");
    const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
    const initData = {
        personal_balance_sheet_info_self: {
            salutation: 'Mr',
            first_name: '',
            last_name: '',
            initial: '',
            current_address: '',
            current_city: '',
            current_state: '',
            current_zip: '',
            current_country: '',
            current_social_security_number: '',
            current_date_of_birth: moment().format('MM-DD-YYYY'),
            current_residence: '',
            current_owner_type: '',
            current_years: new Date().getFullYear(),
            current_months: new Date().getMonth(),
            current_date: '',
            previous_address: '',
            previous_city: '',
            previous_state: '',
            previous_zip: '',
            previous_date: moment().format('MM-DD-YYYY'),
            previous_owner_type: '',
            previous_years: 0,
            previous_months: 0,
            previous_personal_phone: '',
            previous_work_phone: '',
            employer_name: '',
            employer_address: '',
            employer_city: '',
            employer_state: '',
            employer_zip: '',
            employer_position: '',
            employer_title: '',
            employer_service_yrs: 0,
            employer_service_months: 0,
            previous_employer_name: '',
            previous_employer_service_yrs: 0,
            previous_employer_service_months: 0,
            previous_employer_wk_phone: '',
            previous_employer_position: '',
            previous_employer_title: '',
            dependants: [{
                name: '',
                relationship: '',
            }],
        },
        personal_balance_sheet_info_spouse: {
            salutation: 'Mrs',
            first_name: '',
            last_name: '',
            initial: '',
            current_address: '',
            current_city: '',
            current_state: '',
            current_zip: '',
            current_country: '',
            current_social_security_number: '',
            current_date_of_birth: moment().format('MM-DD-YYYY'),
            current_residence: '',
            current_owner_type: '',
            current_years: new Date().getFullYear(),
            current_months: new Date().getMonth(),
            current_date: '',
            previous_address: '',
            previous_city: '',
            previous_state: '',
            previous_zip: '',
            previous_date: moment().format('MM-DD-YYYY'),
            previous_owner_type: '',
            previous_years: 0,
            previous_months: 0,
            previous_personal_phone: '',
            previous_work_phone: '',
            employer_name: '',
            employer_address: '',
            employer_city: '',
            employer_state: '',
            employer_zip: '',
            employer_position: '',
            employer_title: '',
            employer_service_yrs: 0,
            employer_service_months: 0,
            previous_employer_name: '',
            previous_employer_service_yrs: 0,
            previous_employer_service_months: 0,
            previous_employer_wk_phone: '',
            previous_employer_position: '',
            previous_employer_title: '',
            dependants: [{
                name: '',
                relationship: '',
            }],
        },
        balance_sheet_assets: [],
        balance_sheet_liabilities: [],
        personal_balance_sheet_annual_income: [],
        personal_balance_sheet_section_one_cash_type: [],
        personal_balance_sheet_section_one_retirement_type: [],
        personal_balance_sheet_section_one_certificate_type: [],
        personal_balance_sheet_section_two_equities: [],
        personal_balance_sheet_section_two_equities_loan: [],
        personal_balance_sheet_section_two_bonds: [],
        personal_balance_sheet_section_two_bonds_loan: [],
        personal_balance_sheet_section_two_securities: [],
        personal_balance_sheet_section_two_securities_loan: [],
        personal_balance_sheet_section_three_life_insurance: [],
        personal_balance_sheet_section_four_receivable_due: [],
        personal_balance_sheet_section_five_real_estate_primary_property: [],
        personal_balance_sheet_section_five_real_estate_other_property: [],
        section_six_profit_sharing: [],
        section_seven_automobiles: [],
        section_eight_personal_property: [],
        section_nine_notes: [],
        section_nine_other_notes: [],
        section_ten: [],
    }
    const branchData = useSelector(getBranch)
    const contentRef = useRef<HTMLDivElement>(null);
    const pagesRefs = useRef<(HTMLDivElement | null)[]>([]);
    const inputRef = useRef<HTMLInputElement>(null);

    const { getPersonalBalanceSheet, createPersonalBalanceSheet } = useFourThreeThreeBApi();
    const [currentMonthIndex, setCurrentMonthIndex] = useState<any>(new Date().getMonth());
    const currentMonthName = months[currentMonthIndex];
    const [showLoader, setShowLoader] = useState<boolean>(false)
    const [searchParams, setSearchParams] = useState<any>({
        month: { value: new Date().getMonth() + 1, label: currentMonthName },
        year: { value: new Date().getFullYear(), label: '' + new Date().getFullYear() }
    });
    const [isEdit, setIsEdit] = useState<boolean>(false);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [showSubmitButton, setShowSubmitButton] = useState<boolean>(false)
    const [totalBSAssets, setTotalBSAssets] = useState<number>(0);
    const [totalBSLiabilities, setTotalBSLiabilities] = useState<number>(0);
    const [totalBSNetWorth, setTotalBSNetWorth] = useState<number>(0);
    const [totalAnnualIncomeSelf, setTotalAnnualIncomeSelf] = useState<number>(0);
    const [totalAnnualIncomeSpouse, setTotalAnnualIncomeSpouse] = useState<number>(0);

    const [totalSectionOneCashType, setTotalSectionOneCashType] = useState<number>(0);
    const [totalSectionOneRetiementType, setTotalSectionOneRetiementType] = useState<number>(0);
    const [totalSectionOneCertificateType, setTotalSectionOneCertificateType] = useState<number>(0);

    const [totalEquities, setTotalEquities] = useState<number>(0);
    const [totalEquitiesLoan, setTotalEquitiesLoan] = useState<number>(0);
    const [totalEquityNetWorth, setTotalEquityNetWorth] = useState<number>(0);

    const [totalBonds, setTotalBonds] = useState<number>(0);
    const [totalBondsLoan, setTotalBondsLoan] = useState<number>(0);
    const [totalBondsNetWorth, setTotalBondsNetWorth] = useState<number>(0);

    const [totalSecurity, setTotalSecurity] = useState<number>(0);
    const [totalSecurityLoan, setTotalSecurityLoan] = useState<number>(0);
    const [totalSecurityNetWorth, setTotalSecurityNetWorth] = useState<number>(0);

    const [totalInsuranceTerm, setTotalInsuranceTerm] = useState<number>(0);
    const [totalInsuranceWhole, setTotalInsuranceWhole] = useState<number>(0);
    const [totalInsuranceLoan, setTotalInsuranceLoan] = useState<number>(0);

    const [totalReceivableDue, setTotalReceivableDue] = useState<number>(0);

    const [totalRealEstatePrimaryMrkt, setTotalRealEstatePrimaryMrkt] = useState<number>(0);
    const [totalRealEstatePrimaryMortgage, setTotalRealEstatePrimaryMortgage] = useState<number>(0);
    const [totalRealEstateOtherMrkt, setTotalRealEstateOtherMrkt] = useState<number>(0);
    const [totalRealEstateOtherMortgage, setTotalRealEstateOtherMortgage] = useState<number>(0);

    const [totalPensionValue, setTotalPensionValue] = useState<number>(0);
    const [totalPensionVested, setTotalPensionVested] = useState<number>(0);
    const [totalPensionLoan, setTotalPensionLoan] = useState<number>(0);

    const [totalAutoMobileLoan, setTotalAutoMobileLoan] = useState<number>(0);
    const [totalAutoMobileAppraisal, setTotalAutoMobileAppraisal] = useState<number>(0);
    const [totalAutoMobileValue, setTotalAutoMobileValue] = useState<number>(0);

    const [totalPropertyLoan, setTotalPropertyLoan] = useState<number>(0);
    const [totalPropertyAppraisal, setTotalPropertyAppraisal] = useState<number>(0);
    const [totalPropertyValue, setTotalPropertyValue] = useState<number>(0);

    const [totalFinancial, setTotalFinancial] = useState<number>(0);
    const [totalLiabilities, setTotalLiabilities] = useState<number>(0);

    const [totalSectionTen, setTotalSectionTen] = useState<number>(0);

    useEffect(() => {
        setTotalBSNetWorth(totalBSAssets - totalBSLiabilities)
    }, [totalBSAssets, totalBSLiabilities])
    useEffect(() => {
        setTotalEquityNetWorth(totalEquities - totalEquitiesLoan)
    }, [totalEquities, totalEquitiesLoan])
    useEffect(() => {
        setTotalBondsNetWorth(totalBonds - totalBondsLoan)
    }, [totalBonds, totalBondsLoan])
    useEffect(() => {
        setTotalSecurityNetWorth(totalSecurity - totalSecurityLoan)
    }, [totalSecurity, totalSecurityLoan])

    const { control, register, reset, setValue, getValues, watch, handleSubmit, formState: { errors } } = useForm<PersonalBalanceFormI>({
        defaultValues: initData,
        resolver: yupResolver(PersonalBalanceValidate)
    });

    useEffect(() => {
        // reset(initData);
        // initialiseForm();
        fetchMonthlyIncome();
    }, [])

    useEffect(() => {
        const found = balanceSheetAssetsFields.filter((item: any) => item['description'] === t('data.iraSection1'));
        if (found[0]) {
            found[0].amount = totalSectionOneRetiementType + totalSectionOneCertificateType;
            setValue('balance_sheet_assets', balanceSheetAssetsFields);
            calculateTotalBSAssets();
        }
    }, [totalSectionOneRetiementType, totalSectionOneCertificateType])
    useEffect(() => {
        const found = balanceSheetAssetsFields.filter((item: any) => item['description'] === t('data.equitiesBondsSecurities'));
        if (found[0]) {
            found[0].amount = totalEquityNetWorth + totalBondsNetWorth + totalSecurityNetWorth;
            setValue('balance_sheet_assets', balanceSheetAssetsFields);
            calculateTotalBSAssets();
        }
    }, [totalEquityNetWorth, totalBondsNetWorth, totalSecurityNetWorth])
    useEffect(() => {
        const found = balanceSheetAssetsFields.filter((item: any) => item['description'] === t('data.lifeInsuranceCashValue'));
        if (found[0]) {
            found[0].amount = totalInsuranceTerm + totalInsuranceWhole;
            setValue('balance_sheet_assets', balanceSheetAssetsFields);
            calculateTotalBSAssets();
        }
    }, [totalInsuranceTerm, totalInsuranceWhole])
    useEffect(() => {
        const found = balanceSheetAssetsFields.filter((item: any) => item['description'] === t('data.receivablesContractPayments'));
        if (found[0]) {
            found[0].amount = totalReceivableDue;
            setValue('balance_sheet_assets', balanceSheetAssetsFields);
            calculateTotalBSAssets();
        }
    }, [totalReceivableDue])
    useEffect(() => {
        const found = balanceSheetAssetsFields.filter((item: any) => item['description'] === t('data.primaryResidence'));
        if (found[0]) {
            found[0].amount = totalRealEstatePrimaryMrkt;
            setValue('balance_sheet_assets', balanceSheetAssetsFields);
            calculateTotalBSAssets();
        }
    }, [totalRealEstatePrimaryMrkt])
    useEffect(() => {
        const found = balanceSheetAssetsFields.filter((item: any) => item['description'] === t('data.otherRealEstate'));
        if (found[0]) {
            found[0].amount = totalRealEstateOtherMrkt;
            setValue('balance_sheet_assets', balanceSheetAssetsFields);
            calculateTotalBSAssets();
        }
    }, [totalRealEstateOtherMrkt])
    useEffect(() => {
        const found = balanceSheetAssetsFields.filter((item: any) => item['description'] === t('data.profitSharingPension'));
        if (found[0]) {
            found[0].amount = totalPensionLoan;
            setValue('balance_sheet_assets', balanceSheetAssetsFields);
            calculateTotalBSAssets();
        }
    }, [totalPensionLoan])
    useEffect(() => {
        const found = balanceSheetAssetsFields.filter((item: any) => item['description'] === t('data.automobiles'));
        if (found[0]) {
            found[0].amount = totalAutoMobileValue;
            setValue('balance_sheet_assets', balanceSheetAssetsFields);
            calculateTotalBSAssets();
        }
    }, [totalAutoMobileValue])
    useEffect(() => {
        const found = balanceSheetAssetsFields.filter((item: any) => item['description'] === t('data.personalProperty'));
        if (found[0]) {
            found[0].amount = totalPropertyAppraisal;
            setValue('balance_sheet_assets', balanceSheetAssetsFields);
            calculateTotalBSAssets();
        }
    }, [totalPropertyAppraisal])
    useEffect(() => {
        const found = balanceSheetLiabilitiesFields.filter((item: any) => item['description'] === t('data.shortTermNotes'));
        if (found[0]) {
            found[0].amount = totalFinancial;
            setValue('balance_sheet_liabilities', balanceSheetLiabilitiesFields);
            calculateTotalBSLiabilities()
        }
    }, [totalFinancial])
    useEffect(() => {
        const found = balanceSheetLiabilitiesFields.filter((item: any) => item['description'] === t('data.otherShortTermLiabilities'));
        if (found[0]) {
            found[0].amount = totalLiabilities;
            setValue('balance_sheet_liabilities', balanceSheetLiabilitiesFields);
            calculateTotalBSLiabilities()
        }
    }, [totalLiabilities])
    useEffect(() => {
        const found = balanceSheetLiabilitiesFields.filter((item: any) => item['description'] === t('data.creditAccountsBills'));
        if (found[0]) {
            found[0].amount = totalSectionTen;
            setValue('balance_sheet_liabilities', balanceSheetLiabilitiesFields);
            calculateTotalBSLiabilities()
        }
    }, [totalSectionTen])
    useEffect(() => {
        const found = balanceSheetLiabilitiesFields.filter((item: any) => item['description'] === t('data.insuranceProfitSharingLoans'));
        if (found[0]) {
            found[0].amount = totalInsuranceLoan + totalPensionLoan;
            setValue('balance_sheet_liabilities', balanceSheetLiabilitiesFields);
            calculateTotalBSLiabilities()
        }
    }, [totalInsuranceLoan, totalPensionLoan])
    useEffect(() => {
        const found = balanceSheetLiabilitiesFields.filter((item: any) => item['description'] === t('data.mortgagesPrimaryResidence'));
        if (found[0]) {
            found[0].amount = totalRealEstatePrimaryMortgage;
            setValue('balance_sheet_liabilities', balanceSheetLiabilitiesFields);
            calculateTotalBSLiabilities()
        }
    }, [totalRealEstatePrimaryMortgage])
    useEffect(() => {
        const found = balanceSheetLiabilitiesFields.filter((item: any) => item['description'] === t('data.mortgagesOtherRealEstate'));
        if (found[0]) {
            found[0].amount = totalRealEstateOtherMortgage;
            setValue('balance_sheet_liabilities', balanceSheetLiabilitiesFields);
            calculateTotalBSLiabilities()
        }
    }, [totalRealEstateOtherMortgage])

    const calculateTotalBSAssets = () => {
        balanceSheetAssetsFields.reduce(
            (acc: number, item: any) => acc + (parseFloat(item.amount) || 0), 0)
        setTotalBSAssets(balanceSheetAssetsFields.reduce((acc: number, item: any) => acc + (parseFloat(item.amount) || 0), 0));
    }
    const calculateTotalBSLiabilities = () => {
        setTotalBSLiabilities(balanceSheetLiabilitiesFields
            .reduce((acc: number, item: any) => acc + (parseFloat(item.amount) || 0), 0));
    }

    const initialiseForm = () => {
        addMoreBalanceSheetAssets([{
            description: t('data.cashSection1'),
            amount: 0,
            read_only: false
        }, {
            description: t('data.iraSection1'),
            amount: 0,
            read_only: true
        }, {
            description: t('data.equitiesBondsSecurities'),
            amount: 0,
            read_only: true
        }, {
            description: t('data.lifeInsuranceCashValue'),
            amount: 0,
            read_only: true
        }, {
            description: t('data.receivablesContractPayments'),
            amount: 0,
            read_only: true
        }, {
            description: t('data.primaryResidence'),
            amount: 0,
            read_only: true
        }, {
            description: t('data.otherRealEstate'),
            amount: 0,
            read_only: true
        }, {
            description: t('data.profitSharingPension'),
            amount: 0,
            read_only: true
        }, {
            description: t('data.automobiles'),
            amount: 0,
            read_only: true
        }, {
            description: t('data.personalProperty'),
            amount: 0,
            read_only: true
        }, {
            description: t('data.otherAssets'),
            amount: 0,
            read_only: false
        }])
        addMoreBalanceSheetLiabilities([{
            description: t('data.shortTermNotes'),
            amount: 0,
            read_only: true
        }, {
            description: t('data.otherShortTermLiabilities'),
            amount: 0,
            read_only: true
        }, {
            description: t('data.creditAccountsBills'),
            amount: 0,
            read_only: true
        }, {
            description: t('data.insuranceProfitSharingLoans'),
            amount: 0,
            read_only: true
        }, {
            description: t('data.mortgagesPrimaryResidence'),
            amount: 0,
            read_only: true
        }, {
            description: t('data.mortgagesOtherRealEstate'),
            amount: 0,
            read_only: true
        }, {
            description: t('data.taxesPayable'),
            amount: 0,
            read_only: false
        }, {
            description: t('data.otherLiabilities'),
            amount: 0,
            read_only: false
        }])
        addMoreAnnualIncome([
            {
                title: t('data.salary'),
                self_amount: 0,
                spouse_amount: 0
            },
            {
                title: t('data.bonusesCommissions'),
                self_amount: 0,
                spouse_amount: 0
            },
            {
                title: t('data.dividendsInterest'),
                self_amount: 0,
                spouse_amount: 0
            },
            {
                title: t('data.netRealEstateIncome'),
                self_amount: 0,
                spouse_amount: 0
            },
            {
                title: t('data.incomeFromAlimony'),
                self_amount: 0,
                spouse_amount: 0
            },
            {
                title: t('data.incomeFromChildSupport'),
                self_amount: 0,
                spouse_amount: 0
            },
            {
                title: t('data.incomeMaintenancePayments'),
                self_amount: 0,
                spouse_amount: 0
            },
            {
                title: t('data.otherList'),
                self_amount: 0,
                spouse_amount: 0
            }
        ]);
        addMoreSectionOneCashType({
            institution_name: '',
            title: '',
            balance_amount: 0
        })
        addMoreSectionOneRetiementType({
            institution_name: '',
            title: '',
            balance_amount: 0
        })
        addMoreSectionOneCertificateType({
            institution_name: '',
            title: '',
            balance_amount: 0
        })
        addMoreSectionTwoEquities({
            owner: '',
            holding_party: '',
            name_of_portfolio: '',
            amount: 0
        })
        addMoreSectionTwoEquitiesLoan({
            loan_against_portfolio: '',
            borrower_name: '',
            guarantor_name: '',
            loan_amount: 0
        })
        addMoreSectionTwoBonds({
            owner: '',
            holding_party: '',
            name_of_portfolio: '',
            amount: 0
        })
        addMoreSectionTwoBondLoan({
            loan_against_portfolio: '',
            borrower_name: '',
            guarantor_name: '',
            loan_amount: 0
        })
        addMoreSectionTwoSecurity({
            owner: '',
            holding_party: '',
            name_of_portfolio: '',
            amount: 0
        })
        addMoreSectionTwoSecurityLoan({
            loan_against_portfolio: '',
            borrower_name: '',
            guarantor_name: '',
            loan_amount: 0
        })
        addMoreSectionThreeLifeInsurance({
            insurance_company_name: '',
            insured_person_name: '',
            beneficiary_name: '',
            term_date: moment().format('MM-DD-YYYY'),
            term_amount: 0,
            whole_life_amount: 0,
            loan_amount: 0,
        })
        addMoreSectionFourReceivableDue({
            debtor_name: '',
            description: '',
            due_date: moment().format('MM-DD-YYYY'),
            repayment_terms: '',
            balance_amount: 0
        })
        addMoreSectionFiveRealEstatePrimaryProperty({
            address: '',
            build_date: new Date().getFullYear(),
            term: '',
            due_date: moment().format('MM-DD-YYYY'),
            monthly_payment_amount: 0,
            purchase_amount: 0,
            market_value_amount: 0,
            mortgage_balance_amount: 0
        })
        addMoreSectionFiveRealEstateOtherProperty({
            address: '',
            build_date: new Date().getFullYear(),
            term: '',
            due_date: moment().format('MM-DD-YYYY'),
            monthly_payment_amount: 0,
            purchase_amount: 0,
            market_value_amount: 0,
            mortgage_balance_amount: 0
        })
        addMoreSectionSixProfitSharing({
            name: '',
            account_type: '',
            value: 0,
            vested: 0,
            loans: 0
        })
        addMoreSectionSevenAutomobiles({
            year: 0,
            make: '',
            model: '',
            miles: '',
            loan_balance: 0,
            apprisal: 0,
            value: 0,
        })
        addMoreSectionEightPersonalProperty({
            description: '',
            insured: '',
            agent: '',
            phone: '',
            apprisal: 0,
            loans: 0,
            value: 0,
        })
        addMoreSectionNineNotes({
            name: '',
            date_borrowed: moment().format('MM-DD-YYYY'),
            amount_borrowed: 0,
            due_date: moment().format('MM-DD-YYYY'),
            payment: 0,
            balance: 0,
        })
        addMoreSectionNineOtherNotes({
            name: '',
            date_borrowed: moment().format('MM-DD-YYYY'),
            amount_borrowed: 0,
            due_date: moment().format('MM-DD-YYYY'),
            payment: 0,
            balance: 0,
        })
        addMoreSectionTen({
            name: '',
            high_balance: 0,
            start_date: moment().format('MM-DD-YYYY'),
            end_date: moment().format('MM-DD-YYYY'),
            payment: 0
        })

        setTotalBSAssets(0);
        setTotalBSLiabilities(0);
        setTotalBSNetWorth(0);
        setTotalAnnualIncomeSelf(0);
        setTotalAnnualIncomeSpouse(0);
        setTotalSectionOneCashType(0);
        setTotalSectionOneRetiementType(0);
        setTotalSectionOneCertificateType(0);
        setTotalEquities(0);
        setTotalEquitiesLoan(0);
        setTotalEquityNetWorth(0);
        setTotalBonds(0);
        setTotalBondsLoan(0);
        setTotalBondsNetWorth(0);
        setTotalSecurity(0);
        setTotalSecurityLoan(0);
        setTotalSecurityNetWorth(0);
        setTotalInsuranceTerm(0);
        setTotalInsuranceWhole(0);
        setTotalInsuranceLoan(0);
        setTotalReceivableDue(0);
        setTotalRealEstatePrimaryMrkt(0);
        setTotalRealEstatePrimaryMortgage(0);
        setTotalRealEstateOtherMrkt(0);
        setTotalRealEstateOtherMortgage(0);
        setTotalPensionValue(0);
        setTotalPensionVested(0);
        setTotalPensionLoan(0);
        setTotalAutoMobileLoan(0);
        setTotalAutoMobileAppraisal(0);
        setTotalAutoMobileValue(0);
        setTotalPropertyLoan(0);
        setTotalPropertyAppraisal(0);
        setTotalPropertyValue(0);
        setTotalFinancial(0);
        setTotalLiabilities(0);
        setTotalSectionTen(0);
        
        setTimeout(() => {
            if ( inputRef.current) {
                inputRef.current.focus();
            }
            window.scrollTo(0, 0)
        }, 0);
    }


    const { fields: selfDependantFields, append: addMoreSelf, remove: deleteSelf } = useFieldArray({
        control,
        name: 'personal_balance_sheet_info_self.dependants',
    });
    const { fields: spouseDependantFields, append: addMoreSpouse, remove: deleteSpouse } = useFieldArray({
        control,
        name: 'personal_balance_sheet_info_spouse.dependants',
    });
    const { fields: balanceSheetAssetsFields, append: addMoreBalanceSheetAssets, remove: deleteBalanceSheetAssets } = useFieldArray({
        control,
        name: 'balance_sheet_assets',
    });
    const { fields: balanceSheetLiabilitiesFields, append: addMoreBalanceSheetLiabilities, remove: deleteBalanceSheetLiabilities } = useFieldArray({
        control,
        name: 'balance_sheet_liabilities',
    });
    const { fields: annualIncomeFields, append: addMoreAnnualIncome, remove: deleteAnnualIncome } = useFieldArray({
        control,
        name: 'personal_balance_sheet_annual_income',
    });
    const { fields: sectionOneCashTypeFields, append: addMoreSectionOneCashType, remove: deleteSectionOneCashType } = useFieldArray({
        control,
        name: 'personal_balance_sheet_section_one_cash_type',
    });
    const { fields: sectionOneRetiementTypeFields, append: addMoreSectionOneRetiementType, remove: deleteSectionOneRetiementType } = useFieldArray({
        control,
        name: 'personal_balance_sheet_section_one_retirement_type',
    });
    const { fields: sectionOneCertificateTypeFields, append: addMoreSectionOneCertificateType, remove: deleteSectionOneCertificateType } = useFieldArray({
        control,
        name: 'personal_balance_sheet_section_one_certificate_type',
    });
    const { fields: sectionTwoEquitiesFields, append: addMoreSectionTwoEquities, remove: deleteSectionTwoEquities } = useFieldArray({
        control,
        name: 'personal_balance_sheet_section_two_equities',
    });
    const { fields: sectionTwoEquitiesLoanFields, append: addMoreSectionTwoEquitiesLoan, remove: deleteSectionTwoEquitiesLoan } = useFieldArray({
        control,
        name: 'personal_balance_sheet_section_two_equities_loan',
    });
    const { fields: sectionTwoBondsFields, append: addMoreSectionTwoBonds, remove: deleteSectionTwoBonds } = useFieldArray({
        control,
        name: 'personal_balance_sheet_section_two_bonds',
    });
    const { fields: sectionTwoBondLoanFields, append: addMoreSectionTwoBondLoan, remove: deleteSectionTwoBondLoan } = useFieldArray({
        control,
        name: 'personal_balance_sheet_section_two_bonds_loan',
    });

    const { fields: sectionTwoSecurityFields, append: addMoreSectionTwoSecurity, remove: deleteSectionTwoSecurity } = useFieldArray({
        control,
        name: 'personal_balance_sheet_section_two_securities',
    });

    const { fields: sectionTwoSecurityLoanFields, append: addMoreSectionTwoSecurityLoan, remove: deleteSectionTwoSecurityLoan } = useFieldArray({
        control,
        name: 'personal_balance_sheet_section_two_securities_loan',
    });

    const { fields: sectionThreeLifeInsuranceFields, append: addMoreSectionThreeLifeInsurance, remove: deleteSectionThreeLifeInsurance } = useFieldArray({
        control,
        name: 'personal_balance_sheet_section_three_life_insurance',
    });

    const { fields: sectionFourReceivableDueFields, append: addMoreSectionFourReceivableDue, remove: deleteSectionFourReceivableDue } = useFieldArray({
        control,
        name: 'personal_balance_sheet_section_four_receivable_due',
    });

    const { fields: sectionFiveRealEstatePrimaryPropertyFields, append: addMoreSectionFiveRealEstatePrimaryProperty, remove: deleteSectionFiveRealEstatePrimaryProperty } = useFieldArray({
        control,
        name: 'personal_balance_sheet_section_five_real_estate_primary_property',
    });

    const { fields: sectionFiveRealEstateOtherPropertyFields, append: addMoreSectionFiveRealEstateOtherProperty, remove: deleteSectionFiveRealEstateOtherProperty } = useFieldArray({
        control,
        name: 'personal_balance_sheet_section_five_real_estate_other_property',
    });

    const { fields: sectionSixProfitSharingFields, append: addMoreSectionSixProfitSharing, remove: deleteSectionSixProfitSharing } = useFieldArray({
        control,
        name: 'section_six_profit_sharing',
    });

    const { fields: sectionSevenAutomobilesFields, append: addMoreSectionSevenAutomobiles, remove: deleteSectionSevenAutomobiles } = useFieldArray({
        control,
        name: 'section_seven_automobiles',
    });

    const { fields: sectionEightPersonalPropertyFields, append: addMoreSectionEightPersonalProperty, remove: deleteSectionEightPersonalProperty } = useFieldArray({
        control,
        name: 'section_eight_personal_property',
    });

    const { fields: sectionNineNotesFields, append: addMoreSectionNineNotes, remove: deleteSectionNineNotes } = useFieldArray({
        control,
        name: 'section_nine_notes',
    });

    const { fields: sectionNineOtherNotesFields, append: addMoreSectionNineOtherNotes, remove: deleteSectionNineOtherNotes } = useFieldArray({
        control,
        name: 'section_nine_other_notes',
    });

    const { fields: sectionTenFields, append: addMoreSectionTen, remove: deleteSectionTen } = useFieldArray({
        control,
        name: 'section_ten',
    });


    const _handleChangeSearchParam = (e: any, type: string) => {
        if (type === 'month') {
            setSearchParams({
                ...searchParams,
                'month': e
            })
        } else if (type === 'year') {
            setSearchParams({
                ...searchParams,
                'year': e
            })
        }
    }

    const fetchMonthlyIncome = () => {
        setIsLoading(true);
        const data = {
            // month: searchParams['month']['value'],
            year: searchParams['year']['value'],
            branch_id: +branchData['id']
        }
        getPersonalBalanceSheet(data, (message: string, resp: any) => {
            const data = resp.data.data;
            reset();

            if (data) {
                setIsEdit(true);
                setShowSubmitButton(false)
                reset({
                    personal_balance_sheet_info_self: data['personal_balance_sheet_info_self'],
                    personal_balance_sheet_info_spouse: data['personal_balance_sheet_info_spouse'],
                })

                data['balance_sheet_assets'].map((item: any) => {
                    addMoreBalanceSheetAssets({ ...item, read_only: true })
                })
                data['balance_sheet_liabilities'].map((item: any) => {
                    addMoreBalanceSheetLiabilities({ ...item, read_only: true })
                })
                var annualSelf = 0, annualSpouse = 0;
                data['personal_balance_sheet_annual_income'].map((item: any) => {
                    annualSelf += (parseFloat(item.self_amount) || 0);
                    annualSpouse += (parseFloat(item.spouse_amount) || 0);
                    addMoreAnnualIncome({ ...item })
                })
                var cashTypeAmount = 0;
                data['personal_balance_sheet_section_one_cash_type'].map((item: any) => {
                    cashTypeAmount += (parseFloat(item.balance_amount) || 0);
                    addMoreSectionOneCashType({ ...item })
                })
                var retiementTypeAmount = 0;
                data['personal_balance_sheet_section_one_retirement_type'].map((item: any) => {
                    retiementTypeAmount += (parseFloat(item.balance_amount) || 0);
                    addMoreSectionOneRetiementType({ ...item })
                })
                var certificateTypeAmount = 0;
                data['personal_balance_sheet_section_one_certificate_type'].map((item: any) => {
                    certificateTypeAmount += (parseFloat(item.balance_amount) || 0);
                    addMoreSectionOneCertificateType({ ...item })
                })
                var equityAmount = 0;
                data['personal_balance_sheet_section_two_equities'].map((item: any) => {
                    equityAmount += (parseFloat(item.amount) || 0);
                    addMoreSectionTwoEquities({ ...item })
                })
                var equityLoanAmount = 0;
                data['personal_balance_sheet_section_two_equities_loan'].map((item: any) => {
                    equityLoanAmount += (parseFloat(item.loan_amount) || 0);
                    addMoreSectionTwoEquitiesLoan({ ...item })
                })
                var bondAmount = 0;
                data['personal_balance_sheet_section_two_bonds'].map((item: any) => {
                    bondAmount += (parseFloat(item.amount) || 0);
                    addMoreSectionTwoBonds({ ...item })
                })
                var bondLoanAmount = 0;
                data['personal_balance_sheet_section_two_bonds_loan'].map((item: any) => {
                    bondLoanAmount += (parseFloat(item.loan_amount) || 0);
                    addMoreSectionTwoBondLoan({ ...item })
                })
                var securityAmount = 0;
                data['personal_balance_sheet_section_two_securities'].map((item: any) => {
                    securityAmount += (parseFloat(item.amount) || 0);
                    addMoreSectionTwoSecurity({ ...item })
                })
                var securityLoanAmount = 0;
                data['personal_balance_sheet_section_two_securities_loan'].map((item: any) => {
                    securityLoanAmount += (parseFloat(item.loan_amount) || 0);
                    addMoreSectionTwoSecurityLoan({ ...item })
                })
                var insuranceTermAmount = 0, insuranceWholeAmount = 0, insuranceLoanAmount = 0;
                data['personal_balance_sheet_section_three_life_insurance'].map((item: any) => {
                    insuranceTermAmount += (parseFloat(item.term_amount) || 0);
                    insuranceWholeAmount += (parseFloat(item.whole_life_amount) || 0);
                    insuranceLoanAmount += (parseFloat(item.loan_amount) || 0);
                    addMoreSectionThreeLifeInsurance({ ...item })
                })
                var receivableDueAmount = 0;
                data['personal_balance_sheet_section_four_receivable_due'].map((item: any) => {
                    receivableDueAmount += (parseFloat(item.balance_amount) || 0);
                    addMoreSectionFourReceivableDue({ ...item })
                })
                var realEstatePrimaryMrktAmount = 0, realEstatePrimaryMortgageAmount = 0;
                data['personal_balance_sheet_section_five_real_estate_primary_property'].map((item: any) => {
                    realEstatePrimaryMrktAmount += (parseFloat(item.market_value_amount) || 0);
                    realEstatePrimaryMortgageAmount += (parseFloat(item.mortgage_balance_amount) || 0);
                    addMoreSectionFiveRealEstatePrimaryProperty({ ...item })
                })
                var realEstateOtherMrktAmount = 0, realEstateOtherMortgageAmount = 0;
                data['personal_balance_sheet_section_five_real_estate_other_property'].map((item: any) => {
                    realEstateOtherMrktAmount += (parseFloat(item.market_value_amount) || 0);
                    realEstateOtherMortgageAmount += (parseFloat(item.mortgage_balance_amount) || 0);
                    // console.log('personal_balance_sheet_section_five_real_estate_other_property: ', item)
                    addMoreSectionFiveRealEstateOtherProperty({ ...item })
                })
                var pensionValueAmount = 0, pensionVestedAmount = 0, pensionLoanAmount = 0;
                data['section_six_profit_sharing'].map((item: any) => {
                    pensionValueAmount += (parseFloat(item.value) || 0);
                    pensionVestedAmount += (parseFloat(item.vested) || 0);
                    pensionLoanAmount += (parseFloat(item.loans) || 0);
                    addMoreSectionSixProfitSharing({ ...item })
                })
                var autoMobileLoanAmount = 0, autoMobileAppraisalAmount = 0, autoMobileValueAmount = 0;
                data['section_seven_automobiles'].map((item: any) => {
                    autoMobileLoanAmount += (parseFloat(item.loan_balance) || 0);
                    autoMobileAppraisalAmount += (parseFloat(item.apprisal) || 0);
                    autoMobileValueAmount += (parseFloat(item.value) || 0);
                    addMoreSectionSevenAutomobiles({ ...item })
                })
                var propertyLoanAmount = 0, propertyAppraisalAmount = 0, propertyValueAmount = 0;
                data['section_eight_personal_property'].map((item: any) => {
                    propertyLoanAmount += (parseFloat(item.loans) || 0);
                    propertyAppraisalAmount += (parseFloat(item.apprisal) || 0);
                    propertyValueAmount += (parseFloat(item.value) || 0);
                    addMoreSectionEightPersonalProperty({ ...item })
                })
                var financialAmount = 0;
                data['section_nine_notes'].map((item: any) => {
                    financialAmount += (parseFloat(item.balance) || 0);
                    addMoreSectionNineNotes({ ...item })
                })
                var liabilitiesAmount = 0;
                data['section_nine_other_notes'].map((item: any) => {
                    liabilitiesAmount += (parseFloat(item.balance) || 0);
                    addMoreSectionNineOtherNotes({ ...item })
                })
                var sectionTenAmount = 0;
                data['section_ten'].map((item: any) => {
                    sectionTenAmount += (parseFloat(item['payment']) || 0);
                    addMoreSectionTen({
                        ...item,
                        high_balance: item['high_balance_amount'],
                        payment: item['payment']
                    })
                })


                setTotalAnnualIncomeSelf(annualSelf);
                setTotalAnnualIncomeSpouse(annualSpouse);
                setTotalSectionOneCashType(cashTypeAmount);
                setTotalSectionOneRetiementType(retiementTypeAmount);
                setTotalSectionOneCertificateType(certificateTypeAmount);
                setTotalEquities(equityAmount);
                setTotalEquitiesLoan(equityLoanAmount);
                setTotalBonds(bondAmount);
                setTotalBondsLoan(bondLoanAmount);
                setTotalSecurity(securityAmount);
                setTotalSecurityLoan(securityLoanAmount);
                setTotalInsuranceTerm(insuranceTermAmount);
                setTotalInsuranceWhole(insuranceWholeAmount);
                setTotalInsuranceLoan(insuranceLoanAmount);
                setTotalReceivableDue(receivableDueAmount);
                setTotalRealEstatePrimaryMrkt(realEstatePrimaryMrktAmount);
                setTotalRealEstatePrimaryMortgage(realEstatePrimaryMortgageAmount);
                setTotalRealEstateOtherMrkt(realEstateOtherMrktAmount);
                setTotalRealEstateOtherMortgage(realEstateOtherMortgageAmount);
                setTotalPensionValue(pensionValueAmount);
                setTotalPensionVested(pensionVestedAmount);
                setTotalPensionLoan(pensionLoanAmount);
                setTotalAutoMobileLoan(autoMobileLoanAmount);
                setTotalAutoMobileAppraisal(autoMobileAppraisalAmount);
                setTotalAutoMobileValue(autoMobileValueAmount);
                setTotalPropertyLoan(propertyLoanAmount);
                setTotalPropertyAppraisal(propertyAppraisalAmount);
                setTotalPropertyValue(propertyValueAmount);
                setTotalFinancial(financialAmount);
                setTotalLiabilities(liabilitiesAmount);
                setTotalSectionTen(sectionTenAmount);
                calculateTotalBSAssets();
                calculateTotalBSLiabilities();

                setTimeout(() => {
                    if ( inputRef.current) {
                        inputRef.current.focus();
                    }
                    window.scrollTo(0, 0)
                }, 0);

            } else {
                setIsEdit(false);
                setShowSubmitButton(true);
                reset(initData);
                initialiseForm();
            }

            setIsLoading(false);
        }, (message: string, resp: any) => {
            setIsLoading(false);
        })
    }

    const saveMonthlyIncome = (data: any) => {
        setIsLoading(true);
        const payload = {
            queryString: {
                year: searchParams['year']['value'],
                branch_id: +branchData['id']
            },
            data
        }

        createPersonalBalanceSheet(payload, (message: string, resp: any) => {
            captureContentAndGeneratePDF();
            // generatePdf();
            setIsLoading(false);
            toast.success(message);
        }, (message: string, resp: any) => {
            setIsLoading(false);
            toast.error(message);
        })
    }

    const generatePdf = async () => {
        const element = document.querySelector('.personal-balance-sheet.main-table') as HTMLElement;

        if (!element) {
            alert(t('alert.tableNotFound'));
            return;
        }

        // Use html2pdf.js to generate the PDF
        const opt = {
            margin: 0.5,
            filename: 'personal_balance_sheet.pdf',
            image: { type: 'jpeg', quality: 0.98 },
            html2canvas: { scale: 2 },
            jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' }
        };

        html2pdf()
            .from(element)
            .set(opt)
            .save();
    };


    const captureContentAndGeneratePDF = async () => {
        const pdf = new jsPDF('p', 'pt', 'a4');

        for (let i = 0; i < pagesRefs.current.length; i++) {
            const pageRef = pagesRefs.current[i];

            if (pageRef === null) {
                continue; // Skip if ref is null
            }

            // Capture the content of each page
            const canvas = await html2canvas(pageRef, { scale: 3 });

            // Add a new page if not the first page
            if (i > 0) {
                pdf.addPage();
            }

            // Add the captured content as an image to the PDF
            pdf.addImage(canvas.toDataURL('image/jpeg', 1.0), 'JPEG', 0, 0, pdf.internal.pageSize.getWidth(), pdf.internal.pageSize.getHeight());
        }

        // Save or download the PDF
        pdf.save(`${t('title')}(${searchParams['year']['value']}).pdf`);
    };

    const handleKeyDown = (event: React.KeyboardEvent<HTMLFormElement>) => {
        if (event.key === 'Enter' || event.keyCode === 13) {
            event.preventDefault();
        }
    };

    const submitForm = () => {
        handleSubmit(saveMonthlyIncome)();
    };

    return (
        <div className="main-container flex-grow-1">
            <div className="container-fluid">
                <div className="page-title pb-4 pt-3">
                    <div className="row align-items-center">
                        <div className="col-sm-6 align-items-center d-flex">
                            <h1 className="h3 font-weight-700 mb-0 d-inline-flex">{t('title')}</h1>
                        </div>
                    </div>
                </div>
                <div className="filter-box-top">
                    <div className="row">
                        <div className="col-sm-6">
                            <div className="filter-wrap">
                                <div className="filter-box">
                                    <Select
                                        onChange={(e: any) => _handleChangeSearchParam(e, 'year')}
                                        options={lastYears(5)}
                                        defaultValue={searchParams['year']}
                                        className={'zindex-10'}
                                    />
                                </div>

                                <div className="filter-btn">
                                    <button type="button" onClick={fetchMonthlyIncome}><img src={filterSolidIcon} alt="" />{t('button.generateForm')}</button>
                                </div>
                                <div className="filter-btn">
                                    <div className={`page-loader ${isLoading ? 'visible' : ''}`}>
                                        <div className="loader"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="executive-dashboard personal-balance-sheet">
                    <div style={{ padding: 0, margin: 0, textAlign: 'center' }}>
                        <Form onKeyDown={handleKeyDown} /*onSubmit={handleSubmit(saveMonthlyIncome)}*/>
                            <div>
                                <table className="personal-balance-sheet main-table" ref={ref => pagesRefs.current[0] = ref}>
                                    {/* <div ref={ref => pagesRefs.current[0] = ref}> */}
                                    <tr>
                                        <td>
                                            <h2 className="header">{t('title').toUpperCase()}</h2>
                                            <table className="section-table" id="personal-table">
                                                <tr>
                                                    <td>
                                                        <select className="select " {...register("personal_balance_sheet_info_self.salutation")}>
                                                            <option value="Mr" selected>{t('mr')}</option>
                                                            <option value="Mrs">{t('mrs')}</option>
                                                            <option value="Ms">{t('ms')}</option>
                                                        </select>
                                                    </td>
                                                    <td>
                                                        <input type="text" {...register("personal_balance_sheet_info_self.last_name")} placeholder={t('lastName')} className='' ref={inputRef}
                                                        />
                                                    </td>
                                                    <td>
                                                        <input type="text" {...register("personal_balance_sheet_info_self.first_name")} placeholder={t('firstName')} className='' />
                                                    </td>
                                                    <td>
                                                        <input type="text" {...register("personal_balance_sheet_info_self.initial")} placeholder={t('initial')} className='' />
                                                    </td>
                                                    <td colSpan={2}></td>
                                                </tr>
                                                <tr>
                                                    <td colSpan={6}>{t('primaryResidence')}</td>
                                                </tr>
                                                <tr>
                                                    <td colSpan={6}>
                                                        <input type="text" {...register("personal_balance_sheet_info_self.current_address")} placeholder={t('homeStreet')} className='' />
                                                    </td>
                                                </tr>

                                                <tr>
                                                    <td>{t('city')}</td>
                                                    <td><input type="text" className="" {...register("personal_balance_sheet_info_self.current_city")} placeholder={t('city')} /></td>
                                                    <td>{t('state')}</td>
                                                    <td><input type="text" className="" {...register("personal_balance_sheet_info_self.current_state")} placeholder={t('state')} /></td>
                                                    <td>{t('zipCode')}</td>
                                                    <td>
                                                        <input type="text" className="" {...register("personal_balance_sheet_info_self.current_zip")} placeholder={t('zipCode')} />
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>{t('country')}</td>
                                                    <td><input type="text" className="" {...register("personal_balance_sheet_info_self.current_country")} placeholder={t('country')} /></td>
                                                    <td>{t('socialSecurityNumber')}</td>
                                                    <td><input type="text" className="" {...register("personal_balance_sheet_info_self.current_social_security_number")} placeholder={t('socialSecurityNumber')} /></td>
                                                    <td>{t('dateOfBirth')}</td>
                                                    <td>
                                                        <Controller
                                                            name="personal_balance_sheet_info_self.current_date_of_birth"
                                                            control={control}
                                                            render={({ field }) => (
                                                                <DatePicker
                                                                    key={1}
                                                                    selected={field.value ? new Date(field.value) : new Date()}
                                                                    onChange={(e: any) => {
                                                                        field.onChange(moment(e).format('MM/DD/YYYY'));
                                                                    }}
                                                                    className=''
                                                                    dateFormat={'MM/dd/yyyy'}
                                                                    maxDate={new Date()}
                                                                    calendarIconClassname='tex-end'
                                                                    showYearDropdown
                                                                    scrollableYearDropdown
                                                                    yearDropdownItemNumber={40}
                                                                    showMonthDropdown

                                                                />
                                                            )}
                                                        />
                                                    </td>

                                                    {/* <td><input type="date" {...register("personal_balance_sheet_info_self.current_date_of_birth")} /></td> */}
                                                </tr>
                                                <tr>
                                                    <td>{t('residence')}</td>
                                                    <td><input type="text" className="" {...register("personal_balance_sheet_info_self.current_residence")} placeholder={t('residence')} /></td>
                                                    <td>{t('ownRentOther')}</td>
                                                    <td><input type="text" className="" {...register("personal_balance_sheet_info_self.current_owner_type")} placeholder={t('ownRentOther')} /></td>
                                                    <td>{t('years')}</td>
                                                    <td><input type="number" {...register("personal_balance_sheet_info_self.current_years")} placeholder={t('years')} /></td>
                                                </tr>
                                                <tr>
                                                    <td>{t('months')}</td>
                                                    <td><input type="number" {...register("personal_balance_sheet_info_self.current_months")} placeholder={t('months')} /></td>
                                                    <td>{t('date')}</td>
                                                    <td>
                                                        <Controller
                                                            name="personal_balance_sheet_info_self.current_date"
                                                            control={control}
                                                            render={({ field }) => (
                                                                <>
                                                                    <DatePicker
                                                                        key={2}
                                                                        selected={field.value ? new Date(field.value) : new Date()}
                                                                        onChange={(e: any) => {
                                                                            field.onChange(moment(e).format('MM/DD/YYYY'));
                                                                        }}
                                                                        className=''
                                                                        dateFormat={'MM/dd/yyyy'}
                                                                        maxDate={new Date()}
                                                                        calendarIconClassname='tex-end'
                                                                        showYearDropdown
                                                                        scrollableYearDropdown
                                                                        yearDropdownItemNumber={40}
                                                                        showMonthDropdown
                                                                    />
                                                                </>
                                                            )}
                                                        />
                                                        {/* <input type="date" {...register("personal_balance_sheet_info_self.current_address.date")} /> */}
                                                    </td>
                                                    <td colSpan={2}></td>
                                                </tr>
                                                <tr>
                                                    <td colSpan={6}>{t('previousAddress')}</td>
                                                </tr>
                                                <tr>
                                                    <td colSpan={6}><input type="text" className="" {...register("personal_balance_sheet_info_self.previous_address")} placeholder={t('previousAddressLabel')} /></td>
                                                </tr>
                                                <tr>
                                                    <td>{t('city')}</td>
                                                    <td><input type="text" className="" {...register("personal_balance_sheet_info_self.previous_city")} placeholder={t('city')} /></td>
                                                    <td>{t('state')}</td>
                                                    <td><input type="text" className="" {...register("personal_balance_sheet_info_self.previous_state")} placeholder={t('state')} /></td>
                                                    <td>{t('zipCode')}</td>
                                                    <td><input type="text" className="" {...register("personal_balance_sheet_info_self.previous_zip")} placeholder={t('zipCode')} /></td>

                                                </tr>
                                                <tr>
                                                    <td>{t('date')}</td>
                                                    <td>
                                                        <Controller
                                                            name="personal_balance_sheet_info_self.previous_date"
                                                            control={control}
                                                            render={({ field }) => (
                                                                <>
                                                                    <DatePicker
                                                                        key={3}
                                                                        selected={field.value ? new Date(field.value) : new Date()}
                                                                        onChange={(e: any) => {
                                                                            field.onChange(moment(e).format('MM/DD/YYYY'));
                                                                        }}
                                                                        className=''
                                                                        dateFormat={'MM/dd/yyyy'}
                                                                        maxDate={new Date()}
                                                                        calendarIconClassname='tex-end'
                                                                        showYearDropdown
                                                                        scrollableYearDropdown
                                                                        yearDropdownItemNumber={40}
                                                                        showMonthDropdown
                                                                    />
                                                                </>
                                                            )}
                                                        />
                                                        {/* <input type="date" {...register("personal_balance_sheet_info_self.previous_address.date")} /> */}
                                                    </td>
                                                    <td>{t('ownRentOther')}</td>
                                                    <td><input type="text" className="" {...register("personal_balance_sheet_info_self.previous_owner_type")} placeholder={t('ownRentOther')} /></td>
                                                    <td>{t('years')}</td>
                                                    <td><input type="number" {...register("personal_balance_sheet_info_self.previous_years")} placeholder={t('years')} /></td>
                                                </tr>
                                                <tr>
                                                    <td>{t('months')}</td>
                                                    <td><input type="number" {...register("personal_balance_sheet_info_self.previous_months")} placeholder={t('months')} /></td>
                                                    <td colSpan={4}></td>
                                                </tr>
                                                <tr>
                                                    <td>{t('personalPhone')}</td>
                                                    <td><input type="number" className="" {...register("personal_balance_sheet_info_self.previous_personal_phone")} placeholder={t('personalPhone')} /></td>
                                                    <td>{t('workPhone')}</td>
                                                    <td><input type="number" className="" {...register("personal_balance_sheet_info_self.previous_work_phone")} placeholder={t('workPhone')} /></td>
                                                    <td colSpan={2}></td>
                                                </tr>
                                                <tr>
                                                    <td>{t('employer')}</td>
                                                    <td colSpan={3}><input type="text" className="" {...register("personal_balance_sheet_info_self.employer_name")} placeholder={t('employer')} /></td>
                                                    <td colSpan={2}></td>
                                                </tr>
                                                <tr>
                                                    <td>{t('city')}</td>
                                                    <td><input type="text" className="" {...register("personal_balance_sheet_info_self.employer_city")} placeholder={t('city')} /></td>
                                                    <td>{t('workStreetAddress')}</td>
                                                    <td colSpan={3}><input type="text" className="" {...register("personal_balance_sheet_info_self.employer_address")} placeholder={t('workStreetAddress')} /></td>
                                                </tr>
                                                <tr>
                                                    <td>{t('state')}</td>
                                                    <td><input type="text" className="" {...register("personal_balance_sheet_info_self.employer_state")} placeholder={t('state')} /></td>
                                                    <td>{t('zipCode')}</td>
                                                    <td colSpan={3}><input type="text" className="" {...register("personal_balance_sheet_info_self.employer_zip")} placeholder={t('zipCode')} /></td>
                                                </tr>
                                                <tr>
                                                    <td>{t('position')}</td>
                                                    <td colSpan={2}><input type="text" className="" {...register("personal_balance_sheet_info_self.employer_position")} placeholder={t('position')} /></td>
                                                    <td>{t('jobTitle')}</td>
                                                    <td colSpan={2}><input type="text" className="" {...register("personal_balance_sheet_info_self.employer_title")} placeholder={t('jobTitle')} /></td>
                                                </tr>
                                                <tr>
                                                    <td>{t('serviceYears')}</td>
                                                    <td><input type="number" {...register("personal_balance_sheet_info_self.employer_service_yrs")} placeholder={t('serviceYears')} /></td>
                                                    <td>{t('serviceMonths')}</td>
                                                    <td><input type="number" {...register("personal_balance_sheet_info_self.employer_service_months")} placeholder={t('serviceMonths')} /></td>
                                                    <td colSpan={2}></td>
                                                </tr>
                                                <tr>
                                                    <td>{t('previousEmployer')}</td>
                                                    <td colSpan={2}><input type="text" className="" {...register("personal_balance_sheet_info_self.previous_employer_name")} placeholder={t('previousEmployer')} /></td>
                                                    <td>{t('serviceYears')}</td>
                                                    <td colSpan={2}><input type="number" {...register("personal_balance_sheet_info_self.previous_employer_service_yrs")} placeholder={t('serviceYears')} /></td>
                                                </tr>
                                                <tr>
                                                    <td>{t('serviceMonths')}</td>
                                                    <td><input type="number" {...register("personal_balance_sheet_info_self.previous_employer_service_months")} placeholder={t('serviceMonths')} /></td>
                                                    <td>{t('workPhone')}</td>
                                                    <td colSpan={3}><input type="number" className="" {...register("personal_balance_sheet_info_self.previous_employer_wk_phone")} placeholder={t('workPhone')} /></td>
                                                </tr>
                                                <tr>
                                                    <td>{t('position')}</td>
                                                    <td colSpan={2}><input type="text" className="" {...register("personal_balance_sheet_info_self.previous_employer_position")} placeholder={t('position')} /></td>
                                                    <td>{t('jobTitle')}</td>
                                                    <td colSpan={2}><input type="text" className="" {...register("personal_balance_sheet_info_self.previous_employer_title")} placeholder={t('jobTitle')} /></td>
                                                </tr>
                                                <tr>
                                                    <td colSpan={3}>{t('dependents')}</td>
                                                    <td colSpan={3}>{t('relationship')}</td>
                                                </tr>

                                                {selfDependantFields.map((item, index) => (
                                                    <tr key={item.id}>
                                                        <td colSpan={3}>
                                                            <input type="text" className="" {...register(`personal_balance_sheet_info_self.dependants.${index}.name`)} placeholder={t('name')} />
                                                        </td>
                                                        <td colSpan={3}>
                                                            <input type="text" className="" {...register(`personal_balance_sheet_info_self.dependants.${index}.relationship`)} placeholder={t('relation')} />
                                                        </td>
                                                        {/* <button type="button" onClick={() => remove(index)}>Remove</button> */}
                                                    </tr>
                                                ))}
                                                {
                                                    !isEdit && (
                                                        <tr>
                                                            <td colSpan={6}>
                                                                <button type='button' className="button" onClick={() => addMoreSelf({ name: '', relationship: '' })}>{t('button.addRow')}</button>
                                                            </td>
                                                        </tr>
                                                    ) || <></>
                                                }
                                            </table>
                                        </td>

                                        <td>
                                            <h2 className="header-spouse">{t('header.spouse')}</h2>
                                            <table className="section-table" id="personal-table">
                                                <tr>
                                                    <td>
                                                        <select className="select " {...register("personal_balance_sheet_info_spouse.salutation")}>
                                                            <option value="Mr">{t('mr')}</option>
                                                            <option value="Mrs" selected>{t('mrs')}</option>
                                                            <option value="Ms">{t('ms')}</option>
                                                        </select>
                                                    </td>
                                                    <td>
                                                        <input type="text" {...register("personal_balance_sheet_info_spouse.last_name")} placeholder={t('lastName')} className='' />
                                                    </td>
                                                    <td>
                                                        <input type="text" {...register("personal_balance_sheet_info_spouse.first_name")} placeholder={t('firstName')} className='' />
                                                    </td>
                                                    <td>
                                                        <input type="text" {...register("personal_balance_sheet_info_spouse.initial")} placeholder={t('initial')} className='' />
                                                    </td>
                                                    <td colSpan={2}></td>
                                                </tr>
                                                <tr>
                                                    <td colSpan={6}>{t('primaryResidence')}</td>
                                                </tr>
                                                <tr>
                                                    <td colSpan={6}>
                                                        <input type="text" {...register("personal_balance_sheet_info_spouse.current_address")} placeholder={t('homeStreet')} className='' />
                                                    </td>
                                                </tr>

                                                <tr>
                                                    <td>{t('city')}</td>
                                                    <td><input type="text" className="" {...register("personal_balance_sheet_info_spouse.current_city")} placeholder={t('city')} /></td>
                                                    <td>{t('state')}</td>
                                                    <td><input type="text" className="" {...register("personal_balance_sheet_info_spouse.current_state")} placeholder={t('state')} /></td>
                                                    <td>{t('zipCode')}</td>
                                                    <td><input type="text" className="" {...register("personal_balance_sheet_info_spouse.current_zip")} placeholder={t('zipCode')} /></td>
                                                </tr>
                                                <tr>
                                                    <td>{t('country')}</td>
                                                    <td><input type="text" className="" {...register("personal_balance_sheet_info_spouse.current_country")} placeholder={t('country')} /></td>
                                                    <td>{t('socialSecurityNumber')}</td>
                                                    <td><input type="text" className="" {...register("personal_balance_sheet_info_spouse.current_social_security_number")} placeholder={t('socialSecurityNumber')} /></td>
                                                    <td>{t('dateOfBirth')}</td>
                                                    <td>
                                                        <Controller
                                                            name="personal_balance_sheet_info_spouse.current_date_of_birth"
                                                            control={control}
                                                            render={({ field }) => (
                                                                <>
                                                                    <DatePicker
                                                                        key={4}
                                                                        selected={field.value ? new Date(field.value) : new Date()}
                                                                        onChange={(e: any) => {
                                                                            field.onChange(moment(e).format('MM/DD/YYYY'));
                                                                        }}
                                                                        className=''
                                                                        dateFormat={'MM/dd/yyyy'}
                                                                        maxDate={new Date()}
                                                                        calendarIconClassname='tex-end'
                                                                        showYearDropdown
                                                                        scrollableYearDropdown
                                                                        yearDropdownItemNumber={40}
                                                                        showMonthDropdown
                                                                    />
                                                                </>
                                                            )}
                                                        />
                                                        {/* <input type="date" {...register("personal_balance_sheet_info_spouse.current_address.date_of_birth")} /> */}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>{t('residence')}</td>
                                                    <td><input type="text" className="" {...register("personal_balance_sheet_info_spouse.current_residence")} placeholder={t('residence')} /></td>
                                                    <td>{t('ownRentOther')}</td>
                                                    <td><input type="text" className="" {...register("personal_balance_sheet_info_spouse.current_owner_type")} placeholder={t('ownRentOther')} /></td>
                                                    <td>{t('years')}</td>
                                                    <td><input type="number" {...register("personal_balance_sheet_info_spouse.current_years")} placeholder={t('years')} /></td>
                                                </tr>
                                                <tr>
                                                    <td>{t('months')}</td>
                                                    <td><input type="number" {...register("personal_balance_sheet_info_spouse.current_months")} placeholder={t('months')} /></td>
                                                    <td>{t('date')}</td>
                                                    <td>
                                                        <Controller
                                                            name="personal_balance_sheet_info_spouse.current_date"
                                                            control={control}
                                                            render={({ field }) => (
                                                                <>
                                                                    <DatePicker
                                                                        key={5}
                                                                        selected={field.value ? new Date(field.value) : new Date()}
                                                                        onChange={(e: any) => {
                                                                            field.onChange(moment(e).format('MM/DD/YYYY'));
                                                                        }}
                                                                        className=''
                                                                        dateFormat={'MM/dd/yyyy'}
                                                                        maxDate={new Date()}
                                                                        calendarIconClassname='tex-end'
                                                                        showYearDropdown
                                                                        scrollableYearDropdown
                                                                        yearDropdownItemNumber={40}
                                                                        showMonthDropdown
                                                                    />
                                                                </>
                                                            )}
                                                        />
                                                        {/* <input type="date" {...register("personal_balance_sheet_info_spouse.current_date")} /> */}
                                                    </td>
                                                    <td colSpan={2}></td>
                                                </tr>
                                                <tr>
                                                    <td colSpan={6}>{t('previousAddress')}</td>
                                                </tr>
                                                <tr>
                                                    <td colSpan={6}><input type="text" className="" {...register("personal_balance_sheet_info_spouse.previous_address")} placeholder={t('previousAddressLabel')} /></td>
                                                </tr>
                                                <tr>
                                                    <td>{t('city')}</td>
                                                    <td><input type="text" className="" {...register("personal_balance_sheet_info_spouse.previous_city")} placeholder={t('city')} /></td>
                                                    <td>{t('state')}</td>
                                                    <td><input type="text" className="" {...register("personal_balance_sheet_info_spouse.previous_state")} placeholder={t('state')} /></td>
                                                    <td>{t('zipCode')}</td>
                                                    <td><input type="text" className="" {...register("personal_balance_sheet_info_spouse.previous_zip")} placeholder={t('zipCode')} /></td>

                                                </tr>
                                                <tr>
                                                    <td>{t('date')}</td>
                                                    <td>
                                                        <Controller
                                                            name="personal_balance_sheet_info_spouse.previous_date"
                                                            control={control}
                                                            render={({ field }) => (
                                                                <>
                                                                    <DatePicker
                                                                        key={6}
                                                                        selected={field.value ? new Date(field.value) : new Date()}
                                                                        onChange={(e: any) => {
                                                                            field.onChange(moment(e).format('MM/DD/YYYY'));
                                                                        }}
                                                                        className=''
                                                                        dateFormat={'MM/dd/yyyy'}
                                                                        maxDate={new Date()}
                                                                        calendarIconClassname='tex-end'
                                                                        showYearDropdown
                                                                        scrollableYearDropdown
                                                                        yearDropdownItemNumber={40}
                                                                        showMonthDropdown
                                                                    />
                                                                </>
                                                            )}
                                                        />
                                                        {/* <input type="date" {...register("personal_balance_sheet_info_spouse.previous_date")} /> */}
                                                    </td>
                                                    <td>{t('ownRentOther')}</td>
                                                    <td><input type="text" className="" {...register("personal_balance_sheet_info_spouse.previous_owner_type")} placeholder={t('ownRentOther')} /></td>
                                                    <td>{t('years')}</td>
                                                    <td><input type="number" {...register("personal_balance_sheet_info_spouse.previous_years")} placeholder={t('years')} /></td>
                                                </tr>
                                                <tr>
                                                    <td>{t('months')}</td>
                                                    <td><input type="number" {...register("personal_balance_sheet_info_spouse.previous_months")} placeholder={t('months')} /></td>
                                                    <td colSpan={4}></td>
                                                </tr>
                                                <tr>
                                                    <td>{t('personalPhone')}</td>
                                                    <td><input type="number" className="" {...register("personal_balance_sheet_info_spouse.previous_personal_phone")} placeholder={t('personalPhone')} /></td>
                                                    <td>{t('workPhone')}</td>
                                                    <td><input type="number" className="" {...register("personal_balance_sheet_info_spouse.previous_work_phone")} placeholder={t('workPhone')} /></td>
                                                    <td colSpan={2}></td>
                                                </tr>
                                                <tr>
                                                    <td>{t('employer')}</td>
                                                    <td colSpan={3}><input type="text" className="" {...register("personal_balance_sheet_info_spouse.employer_name")} placeholder={t('employer')} /></td>
                                                    <td colSpan={2}></td>
                                                </tr>
                                                <tr>
                                                    <td>{t('city')}</td>
                                                    <td><input type="text" className="" {...register("personal_balance_sheet_info_spouse.employer_city")} placeholder={t('city')} /></td>
                                                    <td>{t('workStreetAddress')}</td>
                                                    <td colSpan={3}><input type="text" className="" {...register("personal_balance_sheet_info_spouse.employer_address")} placeholder={t('workStreetAddress')} /></td>
                                                </tr>
                                                <tr>
                                                    <td>{t('state')}</td>
                                                    <td><input type="text" className="" {...register("personal_balance_sheet_info_spouse.employer_state")} placeholder={t('state')} /></td>
                                                    <td>{t('zipCode')}</td>
                                                    <td colSpan={3}><input type="text" className="" {...register("personal_balance_sheet_info_spouse.employer_zip")} placeholder={t('zipCode')} /></td>
                                                </tr>
                                                <tr>
                                                    <td>{t('position')}</td>
                                                    <td colSpan={2}><input type="text" className="" {...register("personal_balance_sheet_info_spouse.employer_position")} placeholder={t('position')} /></td>
                                                    <td>{t('jobTitle')}</td>
                                                    <td colSpan={2}><input type="text" className="" {...register("personal_balance_sheet_info_spouse.employer_title")} placeholder={t('jobTitle')} /></td>
                                                </tr>
                                                <tr>
                                                    <td>{t('serviceYears')}</td>
                                                    <td><input type="number" {...register("personal_balance_sheet_info_spouse.employer_service_yrs")} placeholder={t('serviceYears')} /></td>
                                                    <td>{t('serviceMonths')}</td>
                                                    <td><input type="number" {...register("personal_balance_sheet_info_spouse.employer_service_months")} placeholder={t('serviceMonths')} /></td>
                                                    <td colSpan={2}></td>
                                                </tr>
                                                <tr>
                                                    <td>{t('previousEmployer')}</td>
                                                    <td colSpan={2}><input type="text" className="" {...register("personal_balance_sheet_info_spouse.previous_employer_name")} placeholder={t('previousEmployer')} /></td>
                                                    <td>{t('serviceYears')}</td>
                                                    <td colSpan={2}><input type="number" {...register("personal_balance_sheet_info_spouse.previous_employer_service_yrs")} placeholder={t('serviceYearsLabel')} /></td>
                                                </tr>
                                                <tr>
                                                    <td>{t('serviceMonths')}</td>
                                                    <td><input type="number" {...register("personal_balance_sheet_info_spouse.previous_employer_service_months")} placeholder={t('serviceMonthsLabel')} /></td>
                                                    <td>{t('wkPhone')}</td>
                                                    <td colSpan={3}><input type="number" className="" {...register("personal_balance_sheet_info_spouse.previous_employer_wk_phone")} placeholder={t('wkPhone')} /></td>
                                                </tr>
                                                <tr>
                                                    <td>{t('position')}</td>
                                                    <td colSpan={2}><input type="text" className="" {...register("personal_balance_sheet_info_spouse.previous_employer_position")} placeholder={t('position')} /></td>
                                                    <td>{t('jobTitle')}</td>
                                                    <td colSpan={2}><input type="text" className="" {...register("personal_balance_sheet_info_spouse.previous_employer_title")} placeholder={t('jobTitle')} /></td>
                                                </tr>
                                                <tr>
                                                    <td colSpan={3}>{t('dependents')}</td>
                                                    <td colSpan={3}>{t('relationship')}</td>
                                                </tr>
                                                {spouseDependantFields.map((item: any, index: number) => (
                                                    <tr key={item.id}>
                                                        <td colSpan={3}>
                                                            <input type="text" className="" {...register(`personal_balance_sheet_info_spouse.dependants.${index}.name`)} placeholder={t('name')} />
                                                        </td>
                                                        <td colSpan={3}>
                                                            <input type="text" className="" {...register(`personal_balance_sheet_info_spouse.dependants.${index}.relationship`)} placeholder={t('relation')} />
                                                        </td>
                                                        {/* <button type="button" onClick={() => remove(index)}>Remove</button> */}
                                                    </tr>
                                                ))}
                                                {
                                                    !isEdit && (
                                                        <tr>
                                                            <td colSpan={6}>
                                                                <button type='button' className="button" onClick={() => addMoreSpouse({ name: '', relationship: '' })}>{t('button.addRow')}</button>
                                                            </td>
                                                        </tr>
                                                    )
                                                }
                                            </table>
                                        </td>
                                    </tr>
                                    <tr><td colSpan={12} style={{ height: '20px' }}></td></tr>
                                    <tr>
                                        <td colSpan={12}>
                                            <h2 className="header">{t('header.balanceSheet')}</h2>
                                            <table className="section-table">
                                                <tr>
                                                    <td>
                                                        <h2 className="balance-header">{t('header.assets')}</h2>
                                                        <table className="section-table" id="personal-table">
                                                            <tr>
                                                                <td colSpan={3}>{t('label.title')}</td>
                                                                <td colSpan={3}>{t('label.amountInDollars')}</td>
                                                            </tr>
                                                            {balanceSheetAssetsFields.map((item: any, index: number) => (
                                                                <tr key={item.id}>
                                                                    <td colSpan={3}>
                                                                        <input type="text" className={balanceSheetAssetsFields[index]['read_only'] ? 'grey-background' : ''} {...register(`balance_sheet_assets.${index}.description`)} placeholder={t('placeholder.otherAssetsDescribe')} readOnly={balanceSheetAssetsFields[index]['read_only']} />
                                                                    </td>
                                                                    <td colSpan={3}>
                                                                        <input type="number" className={balanceSheetAssetsFields[index]['read_only'] ? 'grey-background' : ''} {...register(`balance_sheet_assets.${index}.amount`)} placeholder={t('placeholder.amount')} readOnly={balanceSheetAssetsFields[index]['read_only']} onChange={(event) => {
                                                                            const newFields = [...balanceSheetAssetsFields];
                                                                            newFields[index].amount = +parseFloat(event.target.value).toFixed(2) || 0;
                                                                            calculateTotalBSAssets();
                                                                        }} />
                                                                    </td>
                                                                    {/* <button type="button" onClick={() => remove(index)}>Remove</button> */}
                                                                </tr>
                                                            ))}
                                                            {
                                                                !isEdit && (
                                                                    <tr>
                                                                        <td colSpan={6}>
                                                                            <button type='button' className="button" onClick={() => addMoreBalanceSheetAssets({ description: '', amount: 0, read_only: false })}>{t('button.addRow')}</button>
                                                                        </td>
                                                                    </tr>
                                                                )
                                                            }

                                                            <tr className="total-row">
                                                                <td colSpan={3}>{t('label.total')}</td>
                                                                <td colSpan={3}>${parseFloat('' + totalBSAssets).toFixed(2)}</td>
                                                            </tr>
                                                        </table>
                                                    </td>

                                                    <td>
                                                        <h2 className="balance-header">{t('header.liabilities')}</h2>
                                                        <table className="section-table" id="personal-table">
                                                            <tr>
                                                                <td colSpan={3}>{t('label.title')}</td>
                                                                <td colSpan={3}>{t('label.amountInDollars')}</td>
                                                            </tr>
                                                            {balanceSheetLiabilitiesFields.map((item: any, index: number) => (
                                                                <tr key={item.id}>
                                                                    <td colSpan={3}>
                                                                        <input type="text" className={balanceSheetLiabilitiesFields[index]['read_only'] ? 'grey-background' : ''} {...register(`balance_sheet_liabilities.${index}.description`)} placeholder={t('placeholder.otherLiabilitiesDescribe')} readOnly={balanceSheetLiabilitiesFields[index]['read_only']} />
                                                                    </td>
                                                                    <td colSpan={3}>
                                                                        <input type="number" className={balanceSheetLiabilitiesFields[index]['read_only'] ? 'grey-background' : ''} {...register(`balance_sheet_liabilities.${index}.amount`)} placeholder={t('placeholder.amount')} readOnly={balanceSheetLiabilitiesFields[index]['read_only']}
                                                                            onChange={(event) => {
                                                                                const newFields = [...balanceSheetLiabilitiesFields];
                                                                                newFields[index].amount = +parseFloat(event.target.value).toFixed(2) || 0;
                                                                                calculateTotalBSLiabilities();
                                                                            }}
                                                                        />
                                                                    </td>
                                                                    {/* <button type="button" onClick={() => remove(index)}>Remove</button> */}
                                                                </tr>
                                                            ))}
                                                            {
                                                                !isEdit && (
                                                                    <tr>
                                                                <td colSpan={6}>
                                                                    <button type='button' className="button" onClick={() => addMoreBalanceSheetLiabilities({ description: '', amount: 0, read_only: false })}>{t('button.addRow')}</button>
                                                                </td>
                                                            </tr>
                                                                )
                                                            }
                                                            
                                                            <tr className="total-row">
                                                                <td colSpan={3}>{t('label.total')}</td>
                                                                <td colSpan={3}>${parseFloat('' + totalBSLiabilities).toFixed(2)}</td>
                                                            </tr>
                                                            <tr className="total-row">
                                                                <td colSpan={3}>{t('label.netWorth')}</td>
                                                                <td colSpan={3}>${parseFloat('' + totalBSNetWorth).toFixed(2)}</td>
                                                            </tr>
                                                        </table>
                                                    </td>
                                                </tr>
                                            </table>
                                        </td>
                                    </tr>
                                    <tr><td colSpan={12} style={{ height: '20px' }}></td></tr>
                                    <tr>
                                        <td colSpan={12}>
                                            <h2 className="header">{t('header.annualIncome')}</h2>
                                            <table className="section-table">
                                                <tr>
                                                    <td colSpan={6}>{t('label.annualIncome')}</td>
                                                    <td colSpan={4}>{t('label.youInDollars')}</td>
                                                    <td colSpan={2}>{t('label.spouseInDollars')}</td>
                                                </tr>
                                                {annualIncomeFields.map((item: any, index: number) => (
                                                    <tr key={item.id}>
                                                        <td colSpan={8}>
                                                            <input
                                                                type='text'
                                                                {...register(`personal_balance_sheet_annual_income.${index}.title`)}
                                                                placeholder={t('placeholder.title')}
                                                            />
                                                        </td>
                                                        <td colSpan={2}>
                                                            <input
                                                                type='number'
                                                                {...register(`personal_balance_sheet_annual_income.${index}.self_amount`)}
                                                                placeholder={t('placeholder.amount')}
                                                                onChange={(event) => {
                                                                    const newFields = [...annualIncomeFields];
                                                                    newFields[index].self_amount = parseFloat(event.target.value) || 0;
                                                                    setTotalAnnualIncomeSelf(annualIncomeFields.reduce((acc: number, item: any) => acc + (parseFloat(item.self_amount) || 0), 0));
                                                                }}
                                                            />
                                                        </td>
                                                        <td colSpan={2}>
                                                            <input
                                                                type='number'
                                                                {...register(`personal_balance_sheet_annual_income.${index}.spouse_amount`)}
                                                                placeholder={t('placeholder.amount')}
                                                                onChange={(event) => {
                                                                    const newFields = [...annualIncomeFields];
                                                                    newFields[index].spouse_amount = parseFloat(event.target.value) || 0;
                                                                    setTotalAnnualIncomeSpouse(annualIncomeFields.reduce((acc: number, item: any) => acc + (parseFloat(item.spouse_amount) || 0), 0));
                                                                }}
                                                            />
                                                        </td>
                                                        {/* <button type="button" onClick={() => deleteAnnualIncome(index)}>Remove</button> */}
                                                    </tr>
                                                ))}
                                                {
                                                    !isEdit && (
                                                        <tr>
                                                    <td colSpan={12}>
                                                        <button type="button" className='button' onClick={() => addMoreAnnualIncome({ title: '', self_amount: 0, spouse_amount: 0 })}>{t('button.addRow')}</button>
                                                    </td>
                                                </tr>
                                                    )
                                                }
                                                
                                                <tr className="total-row">
                                                    <td colSpan={8}>{t('label.total')}</td>
                                                    <td colSpan={2}>${parseFloat('' + totalAnnualIncomeSelf).toFixed(2)}</td>
                                                    <td colSpan={2}>${parseFloat('' + totalAnnualIncomeSpouse).toFixed(2)}</td>
                                                </tr>
                                            </table>
                                        </td>
                                    </tr>
                                </table>
                                {/* </div> */}
                                {/* <div ref={ref => pagesRefs.current[1] = ref}> */}
                                <table className="personal-balance-sheet main-table" ref={ref => pagesRefs.current[1] = ref}>
                                    <tr><td colSpan={12} style={{ height: '20px' }}></td></tr>
                                    <tr>
                                        <td colSpan={12}>
                                            <div className="collapsible-header" onClick={() => { }}>
                                                {t('section.one.title')}
                                            </div>
                                            <div className="collapsible-content" id="collapsible-section-1">
                                                <table className="section-table">
                                                    <tr>
                                                        <td colSpan={6}>{t('section.one.bankOrFinancialInstitution')}</td>
                                                        <td colSpan={4}>{t('section.one.cashSavingsChecking')}</td>
                                                        <td colSpan={2}>{t('section.one.balanceInDollars')}</td>
                                                    </tr>
                                                    {sectionOneCashTypeFields.map((item: any, index: number) => (
                                                        <tr key={item.id}>
                                                            <td colSpan={6}>
                                                                <input
                                                                    type='text'
                                                                    {...register(`personal_balance_sheet_section_one_cash_type.${index}.institution_name`)}
                                                                    placeholder={t('placeholder.institutionName')}
                                                                />
                                                            </td>
                                                            <td colSpan={4}>
                                                                <input
                                                                    type='text'
                                                                    {...register(`personal_balance_sheet_section_one_cash_type.${index}.title`)}
                                                                    placeholder={t('placeholder.title')}
                                                                />
                                                            </td>
                                                            <td colSpan={2}>
                                                                <input
                                                                    type='number'
                                                                    {...register(`personal_balance_sheet_section_one_cash_type.${index}.balance_amount`)}
                                                                    placeholder={t('placeholder.balance')}
                                                                    onChange={(event) => {
                                                                        const newFields = [...sectionOneCashTypeFields];
                                                                        newFields[index].balance_amount = parseFloat(event.target.value) || 0;
                                                                        setTotalSectionOneCashType(sectionOneCashTypeFields.reduce((acc: number, item: any) => acc + (parseFloat(item.balance_amount) || 0), 0));
                                                                    }}
                                                                />
                                                            </td>
                                                            {/* <button type="button" onClick={() => deleteAnnualIncome(index)}>Remove</button> */}
                                                        </tr>
                                                    ))}
                                                    {
                                                        !isEdit && (
                                                            <tr>
                                                        <td colSpan={12}>
                                                            <button type="button" className='button' onClick={() => addMoreSectionOneCashType({ institution_name: '', title: '', balance_amount: 0 })}>{t('button.addRow')}</button>
                                                        </td>
                                                    </tr>
                                                        ) || <></>
                                                    }
                                                    
                                                    <tr className="total-row">
                                                        <td colSpan={10}>{t('label.total')}</td>
                                                        <td colSpan={2}>${parseFloat('' + totalSectionOneCashType).toFixed(2)}</td>
                                                    </tr>

                                                    <tr>
                                                        <td colSpan={6}>{t('section.one.financialInstitution')}</td>
                                                        <td colSpan={4}>{t('section.one.retirementAccounts')}</td>
                                                        <td colSpan={2}>{t('section.one.balanceInDollars')}</td>
                                                    </tr>
                                                    {sectionOneRetiementTypeFields.map((item: any, index: number) => (
                                                        <tr key={item.id}>
                                                            <td colSpan={6}>
                                                                <input
                                                                    type='text'
                                                                    {...register(`personal_balance_sheet_section_one_retirement_type.${index}.institution_name`)}
                                                                    placeholder={t('placeholder.institutionName')}
                                                                />
                                                            </td>
                                                            <td colSpan={4}>
                                                                <input
                                                                    type='text'
                                                                    {...register(`personal_balance_sheet_section_one_retirement_type.${index}.title`)}
                                                                    placeholder={t('placeholder.title')}
                                                                />
                                                            </td>
                                                            <td colSpan={2}>
                                                                <input
                                                                    type='number'
                                                                    {...register(`personal_balance_sheet_section_one_retirement_type.${index}.balance_amount`)}
                                                                    placeholder={t('placeholder.balance')}
                                                                    onChange={(event) => {
                                                                        const newFields = [...sectionOneRetiementTypeFields];
                                                                        newFields[index].balance_amount = parseFloat(event.target.value) || 0;
                                                                        setTotalSectionOneRetiementType(sectionOneRetiementTypeFields.reduce((acc: number, item: any) => acc + (parseFloat(item.balance_amount) || 0), 0));
                                                                    }}
                                                                />
                                                            </td>
                                                            {/* <button type="button" onClick={() => deleteAnnualIncome(index)}>Remove</button> */}
                                                        </tr>
                                                    ))}
                                                    {
                                                        !isEdit && (<tr>
                                                            <td colSpan={12}>
                                                                <button type="button" className='button' onClick={() => addMoreSectionOneRetiementType({ institution_name: '', title: '', balance_amount: 0 })}>{t('button.addRow')}</button>
                                                            </td>
                                                        </tr>)
                                                    }
                                                    
                                                    <tr className="total-row">
                                                        <td colSpan={10}>{t('label.total')}</td>
                                                        <td colSpan={2}>${parseFloat('' + totalSectionOneRetiementType).toFixed(2)}</td>
                                                    </tr>

                                                    <tr>
                                                        <td colSpan={6}>{t('section.one.financialInstitution')}</td>
                                                        <td colSpan={4}>{t('section.one.certificatesOther')}</td>
                                                        <td colSpan={2}>{t('section.one.balanceInDollars')}</td>
                                                    </tr>
                                                    {sectionOneCertificateTypeFields.map((item: any, index: number) => (
                                                        <tr key={item.id}>
                                                            <td colSpan={6}>
                                                                <input
                                                                    type='text'
                                                                    {...register(`personal_balance_sheet_section_one_certificate_type.${index}.institution_name`)}
                                                                    placeholder={t('description')}
                                                                />
                                                            </td>
                                                            <td colSpan={4}>
                                                                <input
                                                                    type='text'
                                                                    {...register(`personal_balance_sheet_section_one_certificate_type.${index}.title`)}
                                                                    placeholder={t('placeholder.title')}
                                                                />
                                                            </td>
                                                            <td colSpan={2}>
                                                                <input
                                                                    type='number'
                                                                    {...register(`personal_balance_sheet_section_one_certificate_type.${index}.balance_amount`)}
                                                                    placeholder={t('balance')}
                                                                    onChange={(event) => {
                                                                        const newFields = [...sectionOneCertificateTypeFields];
                                                                        newFields[index].balance_amount = parseFloat(event.target.value) || 0;
                                                                        setTotalSectionOneCertificateType(sectionOneCertificateTypeFields.reduce((acc: number, item: any) => acc + (parseFloat(item.balance_amount) || 0), 0));
                                                                    }}
                                                                />
                                                            </td>
                                                            {/* <button type="button" onClick={() => deleteAnnualIncome(index)}>Remove</button> */}
                                                        </tr>
                                                    ))}
                                                    {
                                                        !isEdit && (
                                                            <tr>
                                                        <td colSpan={12}>
                                                            <button type="button" className='button' onClick={() => addMoreSectionOneCertificateType({ institution_name: '', title: '', balance_amount: 0 })}>{t('button.addRow')}</button>
                                                        </td>
                                                    </tr>
                                                        )
                                                    }
                                                    
                                                    <tr className="total-row">
                                                        <td colSpan={10}>{t('label.total')}</td>
                                                        <td colSpan={2}>${parseFloat('' + totalSectionOneCertificateType).toFixed(2)}</td>
                                                    </tr>
                                                </table>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr><td colSpan={12} style={{ height: '20px' }}></td></tr>
                                    <tr>
                                        <td colSpan={12}>
                                            <div className="collapsible-header" onClick={() => { }}>
                                                {t('section.two.equities.title')}
                                            </div>
                                            <div className="collapsible-content" id="collapsible-section-1">
                                                <table className="section-table">
                                                    <tr>
                                                        <td colSpan={4}>{t('section.two.ownerOfPortfolio')}</td>
                                                        <td colSpan={4}>{t('section.two.brokerageHoldingEquity')}</td>
                                                        <td colSpan={2}>{t('section.two.nameOfPortfolio')}</td>
                                                        <td colSpan={2}>{t('section.two.portfolioValueInDollars')}</td>
                                                    </tr>
                                                    {sectionTwoEquitiesFields.map((item: any, index: number) => (
                                                        <tr key={item.id}>
                                                            <td colSpan={4}>
                                                                <input
                                                                    type='text'
                                                                    {...register(`personal_balance_sheet_section_two_equities.${index}.owner`)}
                                                                    placeholder={t('placeholder.owner')}
                                                                />
                                                            </td>
                                                            <td colSpan={4}>
                                                                <input
                                                                    type='text'
                                                                    {...register(`personal_balance_sheet_section_two_equities.${index}.holding_party`)}
                                                                    placeholder={t('placeholder.holdingParty')}
                                                                />
                                                            </td>
                                                            <td colSpan={2}>
                                                                <input
                                                                    {...register(`personal_balance_sheet_section_two_equities.${index}.name_of_portfolio`)}
                                                                    placeholder={t('placeholder.portfolioName')}
                                                                />
                                                            </td>
                                                            <td colSpan={2}>
                                                                <input
                                                                    type='number'
                                                                    {...register(`personal_balance_sheet_section_two_equities.${index}.amount`)}
                                                                    placeholder={t("amount")}
                                                                    onChange={(event) => {
                                                                        const newFields = [...sectionTwoEquitiesFields];
                                                                        newFields[index].amount = parseFloat(event.target.value) || 0;
                                                                        setTotalEquities(sectionTwoEquitiesFields.reduce((acc: number, item: any) => acc + (parseFloat(item.amount) || 0), 0));
                                                                    }}
                                                                />
                                                            </td>
                                                        </tr>
                                                    ))}
                                                    {
                                                        !isEdit && (
                                                            <tr>
                                                        <td colSpan={12}>
                                                            <button type="button" className='button' onClick={() => addMoreSectionTwoEquities({ owner: '', holding_party: '', name_of_portfolio: '', amount: 0 })}>{t('button.addRow')}</button>
                                                        </td>
                                                    </tr>
                                                        )
                                                    }
                                                    
                                                    <tr>
                                                        <td colSpan={4}>{t('section.two.loanAgainstPortfolio')}</td>
                                                        <td colSpan={4}>{t('section.two.nameOfBorrower')}</td>
                                                        <td colSpan={2}>{t('section.two.nameOfPortfolioGuaranteeing')}</td>
                                                        <td colSpan={2}>{t('section.two.amountOfLoanInDollars')}</td>
                                                    </tr>
                                                    {sectionTwoEquitiesLoanFields.map((item: any, index: number) => (
                                                        <tr key={item.id}>
                                                            <td colSpan={4}>
                                                                <input
                                                                    type='text'
                                                                    {...register(`personal_balance_sheet_section_two_equities_loan.${index}.loan_against_portfolio`)}
                                                                    placeholder={t("loan")}
                                                                />
                                                            </td>
                                                            <td colSpan={4}>
                                                                <input
                                                                    type='text'
                                                                    {...register(`personal_balance_sheet_section_two_equities_loan.${index}.borrower_name`)}
                                                                    placeholder={t("borrowerName")}
                                                                />
                                                            </td>
                                                            <td colSpan={2}>
                                                                <input
                                                                    type='text'
                                                                    {...register(`personal_balance_sheet_section_two_equities_loan.${index}.guarantor_name`)}
                                                                    placeholder={t("guarantorName")}
                                                                />
                                                            </td>
                                                            <td colSpan={2}>
                                                                <input
                                                                    type='number'
                                                                    {...register(`personal_balance_sheet_section_two_equities_loan.${index}.loan_amount`)}
                                                                    placeholder={t("amount")}
                                                                    onChange={(event) => {
                                                                        const newFields = [...sectionTwoEquitiesLoanFields];
                                                                        newFields[index].loan_amount = parseFloat(event.target.value) || 0;
                                                                        setTotalEquitiesLoan(sectionTwoEquitiesLoanFields.reduce((acc: number, item: any) => acc + (parseFloat(item.loan_amount) + 0), 0));
                                                                    }}
                                                                />
                                                            </td>
                                                        </tr>
                                                    ))}
                                                    {
                                                        !isEdit && (
                                                            <tr>
                                                        <td colSpan={12}>
                                                            <button type="button" className='button' onClick={() => addMoreSectionTwoEquitiesLoan({ loan_against_portfolio: '', borrower_name: '', guarantor_name: '', loan_amount: 0 })}>{t('button.addRow')}</button>
                                                        </td>
                                                    </tr>
                                                        )
                                                    }
                                                    
                                                    <tr className="total-row">
                                                        <td colSpan={10}>{t('label.total')}</td>
                                                        <td colSpan={2}>${parseFloat('' + totalEquityNetWorth).toFixed(2)}</td>
                                                    </tr>
                                                </table>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr><td colSpan={12} style={{ height: '20px' }}></td></tr>
                                    <tr>
                                        <td colSpan={12}>
                                            <div className="collapsible-header" onClick={() => { }}>
                                                {t('section.two.bonds.title')}
                                            </div>
                                            <div className="collapsible-content" id="collapsible-section-1">
                                                <table className="section-table">
                                                    <tr>
                                                        <td colSpan={4}>{t('section.two.ownerOfPortfolio')}</td>
                                                        <td colSpan={4}>{t('section.two.brokerageHoldingEquity')}</td>
                                                        <td colSpan={2}>{t('section.two.nameOfPortfolio')}</td>
                                                        <td colSpan={2}>{t('section.two.portfolioValueInDollars')}</td>
                                                    </tr>
                                                    {sectionTwoBondsFields.map((item: any, index: number) => (
                                                        <tr key={item.id}>
                                                            <td colSpan={4}>
                                                                <input
                                                                    type='text'
                                                                    {...register(`personal_balance_sheet_section_two_bonds.${index}.owner`)}
                                                                    placeholder={t("owner")}
                                                                />
                                                            </td>
                                                            <td colSpan={4}>
                                                                <input
                                                                    type='text'
                                                                    {...register(`personal_balance_sheet_section_two_bonds.${index}.holding_party`)}
                                                                    placeholder={t("holdingParty")}
                                                                />
                                                            </td>
                                                            <td colSpan={2}>
                                                                <input
                                                                    type='text'
                                                                    {...register(`personal_balance_sheet_section_two_bonds.${index}.name_of_portfolio`)}
                                                                    placeholder={t("portfolio")}
                                                                />
                                                            </td>
                                                            <td colSpan={2}>
                                                                <input
                                                                    type='number'
                                                                    {...register(`personal_balance_sheet_section_two_bonds.${index}.amount`)}
                                                                    placeholder={t("amount")}
                                                                    onChange={(event) => {
                                                                        const newFields = [...sectionTwoBondsFields];
                                                                        newFields[index].amount = parseFloat(event.target.value) || 0;
                                                                        setTotalBonds(sectionTwoBondsFields.reduce((acc: number, item: any) => acc + (parseFloat(item.amount) || 0), 0));
                                                                    }}
                                                                />
                                                            </td>
                                                        </tr>
                                                    ))}
                                                    {
                                                        !isEdit && (
                                                            <tr>
                                                        <td colSpan={12}>
                                                            <button type="button" className='button' onClick={() => addMoreSectionTwoBonds({ owner: '', holding_party: '', name_of_portfolio: '', amount: 0 })}>{t('button.addRow')}</button>
                                                        </td>
                                                    </tr>
                                                        )
                                                    }
                                                    <tr>
                                                        <td colSpan={4}>{t('section.two.loanAgainstPortfolio')}</td>
                                                        <td colSpan={4}>{t('section.two.nameOfBorrower')}</td>
                                                        <td colSpan={2}>{t('section.two.nameOfPortfolioGuaranteeing')}</td>
                                                        <td colSpan={2}>{t('section.two.amountOfLoanInDollars')}</td>
                                                    </tr>
                                                    {sectionTwoBondLoanFields.map((item: any, index: number) => (
                                                        <tr key={item.id}>
                                                            <td colSpan={4}>
                                                                <input
                                                                    type='text'
                                                                    {...register(`personal_balance_sheet_section_two_bonds_loan.${index}.loan_against_portfolio`)}
                                                                    placeholder={t("loan")}
                                                                />
                                                            </td>
                                                            <td colSpan={4}>
                                                                <input
                                                                    type='text'
                                                                    {...register(`personal_balance_sheet_section_two_bonds_loan.${index}.borrower_name`)}
                                                                    placeholder={t("borrower")}
                                                                />
                                                            </td>
                                                            <td colSpan={2}>
                                                                <input
                                                                    type='text'
                                                                    {...register(`personal_balance_sheet_section_two_bonds_loan.${index}.guarantor_name`)}
                                                                    placeholder={t("name")}
                                                                />
                                                            </td>
                                                            <td colSpan={2}>
                                                                <input
                                                                    type='number'
                                                                    {...register(`personal_balance_sheet_section_two_bonds_loan.${index}.loan_amount`)}
                                                                    placeholder={t("amount")}
                                                                    onChange={(event) => {
                                                                        const newFields = [...sectionTwoBondLoanFields];
                                                                        newFields[index].loan_amount = parseFloat(event.target.value) || 0;
                                                                        setTotalBondsLoan(sectionTwoBondLoanFields.reduce((acc: number, item: any) => acc + (parseFloat(item.loan_amount) || 0), 0));
                                                                    }}
                                                                />
                                                            </td>
                                                        </tr>
                                                    ))}
                                                    {
                                                        !isEdit && (
                                                            <tr>
                                                        <td colSpan={12}>
                                                            <button type="button" className='button' onClick={() => addMoreSectionTwoBondLoan({ loan_against_portfolio: '', borrower_name: '', guarantor_name: '', loan_amount: 0 })}>{t('button.addRow')}</button>
                                                        </td>
                                                    </tr>
                                                        )
                                                    }
                                                    
                                                    <tr className="total-row">
                                                        <td colSpan={10}>{t('label.total')}</td>
                                                        <td colSpan={2}>${parseFloat('' + totalBondsNetWorth).toFixed(2)}</td>
                                                    </tr>
                                                </table>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr><td colSpan={12} style={{ height: '20px' }}></td></tr>
                                    <tr>
                                        <td colSpan={12}>
                                            <div className="collapsible-header" onClick={() => { }}>
                                                {t('section.two.otherSecurities.title')}
                                            </div>
                                            <div className="collapsible-content" id="collapsible-section-1">
                                                <table className="section-table">
                                                    <tr>
                                                        <td colSpan={4}>{t('section.two.ownerOfPortfolio')}</td>
                                                        <td colSpan={4}>{t('section.two.brokerageHoldingEquity')}</td>
                                                        <td colSpan={2}>{t('section.two.nameOfPortfolio')}</td>
                                                        <td colSpan={2}>{t('section.two.portfolioValueInDollars')}</td>
                                                    </tr>
                                                    {sectionTwoSecurityFields.map((item: any, index: number) => (
                                                        <tr key={item.id}>
                                                            <td colSpan={4}>
                                                                <input
                                                                    type='text'
                                                                    {...register(`personal_balance_sheet_section_two_securities.${index}.owner`)}
                                                                    placeholder={t("owner")}
                                                                />
                                                            </td>
                                                            <td colSpan={4}>
                                                                <input
                                                                    type='text'
                                                                    {...register(`personal_balance_sheet_section_two_securities.${index}.holding_party`)}
                                                                    placeholder={t("holdingBond")}
                                                                />
                                                            </td>
                                                            <td colSpan={2}>
                                                                <input
                                                                    type='text'
                                                                    {...register(`personal_balance_sheet_section_two_securities.${index}.name_of_portfolio`)}
                                                                    placeholder={t("name")}
                                                                />
                                                            </td>
                                                            <td colSpan={2}>
                                                                <input
                                                                    type='number'
                                                                    {...register(`personal_balance_sheet_section_two_securities.${index}.amount`)}
                                                                    placeholder={t("amount")}
                                                                    onChange={(event) => {
                                                                        const newFields = [...sectionTwoSecurityFields];
                                                                        newFields[index].amount = parseFloat(event.target.value) || 0;
                                                                        setTotalSecurity(sectionTwoSecurityFields.reduce((acc: number, item: any) => acc + (parseFloat(item.amount) || 0), 0));
                                                                    }}
                                                                />
                                                            </td>
                                                        </tr>
                                                    ))}
                                                    {
                                                        !isEdit && (
                                                            <tr>
                                                        <td colSpan={12}>
                                                            <button type="button" className='button' onClick={() => addMoreSectionTwoSecurity({ owner: '', holding_party: '', name_of_portfolio: '', amount: 0 })}>{t('button.addRow')}</button>
                                                        </td>
                                                    </tr>
                                                        )
                                                    }
                                                    
                                                    <tr>
                                                        <td colSpan={4}>{t('section.two.loanAgainstPortfolio')}</td>
                                                        <td colSpan={4}>{t('section.two.nameOfBorrower')}</td>
                                                        <td colSpan={2}>{t('section.two.nameOfPortfolioGuaranteeing')}</td>
                                                        <td colSpan={2}>{t('section.two.amountOfLoanInDollars')}</td>
                                                    </tr>
                                                    {sectionTwoSecurityLoanFields.map((item: any, index: number) => (
                                                        <tr key={item.id}>
                                                            <td colSpan={4}>
                                                                <input
                                                                    type='text'
                                                                    {...register(`personal_balance_sheet_section_two_securities_loan.${index}.loan_against_portfolio`)}
                                                                    placeholder={t("loan")}
                                                                />
                                                            </td>
                                                            <td colSpan={4}>
                                                                <input
                                                                    type='text'
                                                                    {...register(`personal_balance_sheet_section_two_securities_loan.${index}.borrower_name`)}
                                                                    placeholder={t("name")}
                                                                />
                                                            </td>
                                                            <td colSpan={2}>
                                                                <input
                                                                    type='text'
                                                                    {...register(`personal_balance_sheet_section_two_securities_loan.${index}.guarantor_name`)}
                                                                    placeholder={t("name")}
                                                                />
                                                            </td>
                                                            <td colSpan={2}>
                                                                <input
                                                                    type='number'
                                                                    {...register(`personal_balance_sheet_section_two_securities_loan.${index}.loan_amount`)}
                                                                    placeholder={t("amount")}
                                                                    onChange={(event) => {
                                                                        const newFields = [...sectionTwoSecurityLoanFields];
                                                                        newFields[index].loan_amount = parseFloat(event.target.value) || 0;
                                                                        setTotalSecurityLoan(sectionTwoSecurityLoanFields.reduce((acc: number, item: any) => acc + (parseFloat(item.loan_amount) || 0), 0));
                                                                    }}
                                                                />
                                                            </td>
                                                        </tr>
                                                    ))}
                                                    {
                                                        !isEdit && (
                                                            <tr>
                                                        <td colSpan={12}>
                                                            <button type="button" className='button' onClick={() => addMoreSectionTwoSecurityLoan({ loan_against_portfolio: '', borrower_name: '', guarantor_name: '', loan_amount: 0 })}>{t('button.addRow')}</button>
                                                        </td>
                                                    </tr>
                                                        )
                                                    }
                                                    
                                                    <tr className="total-row">
                                                        <td colSpan={10}>{t('label.total')}</td>
                                                        <td colSpan={2}>${parseFloat('' + totalSecurityNetWorth).toFixed(2)}</td>
                                                    </tr>
                                                </table>
                                            </div>
                                        </td>
                                    </tr>
                                </table>
                                {/* </div> */}
                                {/* <div ref={ref => pagesRefs.current[1] = ref}> */}
                                <table className="personal-balance-sheet main-table" ref={ref => pagesRefs.current[2] = ref}>
                                    <tr><td colSpan={12} style={{ height: '20px' }}></td></tr>
                                    <tr>
                                        <td colSpan={12}>
                                            <div className="collapsible-header" onClick={() => { }}>
                                                {t('section.three.title')}
                                            </div>
                                            <div className="collapsible-content" id="collapsible-section-1">
                                                <table className="section-table">
                                                    <tr>
                                                        <td colSpan={3}>{t('section.three.insuranceCompanyName.header')}</td>
                                                        <td colSpan={3}>{t('section.three.insuredName.header')}</td>
                                                        <td colSpan={2}>{t('section.three.beneficiaryName.header')}</td>
                                                        <td colSpan={1}>{t('section.three.termDate.header')}</td>
                                                        <td colSpan={1}>{t('section.three.termValueInDollars.header')}</td>
                                                        <td colSpan={1}>{t('section.three.wholeLifeInDollars.header')}</td>
                                                        <td colSpan={1}>{t('section.three.loansInDollars.header')}</td>
                                                    </tr>
                                                    {sectionThreeLifeInsuranceFields.map((item: any, index: number) => (
                                                        <tr key={item.id}>
                                                            <td colSpan={3}>
                                                                <input
                                                                    type='text'
                                                                    {...register(`personal_balance_sheet_section_three_life_insurance.${index}.insurance_company_name`)}
                                                                    placeholder={t('placeholder.insuranceCompany')}
                                                                />
                                                            </td>
                                                            <td colSpan={3}>
                                                                <input
                                                                    type='text'
                                                                    {...register(`personal_balance_sheet_section_three_life_insurance.${index}.insured_person_name`)}
                                                                    placeholder={t('placeholder.insuredPerson')}
                                                                />
                                                            </td>
                                                            <td colSpan={2}>
                                                                <input
                                                                    type='text'
                                                                    {...register(`personal_balance_sheet_section_three_life_insurance.${index}.beneficiary_name`)}
                                                                    placeholder={t('placeholder.beneficiary')}
                                                                />
                                                            </td>
                                                            <td colSpan={1}>
                                                                <Controller
                                                                    name={`personal_balance_sheet_section_three_life_insurance.${index}.term_date`}
                                                                    control={control}
                                                                    render={({ field }) => (
                                                                        <>
                                                                            <DatePicker
                                                                                key={7}
                                                                                selected={field.value ? new Date(field.value) : new Date()}
                                                                                onChange={(e: any) => {
                                                                                    field.onChange(moment(e).format('MM/DD/YYYY'));
                                                                                }}
                                                                                className=''
                                                                                dateFormat={'MM/dd/yyyy'}
                                                                                maxDate={new Date()}
                                                                                calendarIconClassname='tex-end'
                                                                                showYearDropdown
                                                                                scrollableYearDropdown
                                                                                yearDropdownItemNumber={40}
                                                                                showMonthDropdown
                                                                            />
                                                                        </>
                                                                    )}
                                                                />
                                                            </td>
                                                            <td colSpan={1}>
                                                                <input
                                                                    type='number'
                                                                    {...register(`personal_balance_sheet_section_three_life_insurance.${index}.term_amount`)}
                                                                    placeholder={t('placeholder.termAmount')}
                                                                    onChange={(event) => {
                                                                        const newFields = [...sectionThreeLifeInsuranceFields];
                                                                        newFields[index].term_amount = parseFloat(event.target.value) || 0;
                                                                        setTotalInsuranceTerm(sectionThreeLifeInsuranceFields.reduce((acc: number, item: any) => acc + (parseFloat(item.term_amount) || 0), 0));
                                                                    }}
                                                                />
                                                            </td>
                                                            <td colSpan={1}>
                                                                <input
                                                                    type='number'
                                                                    {...register(`personal_balance_sheet_section_three_life_insurance.${index}.whole_life_amount`)}
                                                                    placeholder={t('placeholder.wholeLifeAmount')}
                                                                    onChange={(event) => {
                                                                        const newFields = [...sectionThreeLifeInsuranceFields];
                                                                        newFields[index].whole_life_amount = parseFloat(event.target.value) || 0;
                                                                        setTotalInsuranceWhole(sectionThreeLifeInsuranceFields.reduce((acc: number, item: any) => acc + (parseFloat(item.whole_life_amount) || 0), 0));
                                                                    }}
                                                                />
                                                            </td>
                                                            <td colSpan={1}>
                                                                <input
                                                                    type='number'
                                                                    {...register(`personal_balance_sheet_section_three_life_insurance.${index}.loan_amount`)}
                                                                    placeholder={t('placeholder.loanAmount')}

                                                                    onChange={(event) => {
                                                                        const newFields = [...sectionThreeLifeInsuranceFields];
                                                                        newFields[index].loan_amount = parseFloat(event.target.value) || 0;
                                                                        setTotalInsuranceLoan(sectionThreeLifeInsuranceFields.reduce((acc: number, item: any) => acc + (parseFloat(item.loan_amount) || 0), 0));
                                                                    }}
                                                                />
                                                            </td>
                                                        </tr>
                                                    ))}
                                                    {
                                                        !isEdit && (
                                                            <tr>
                                                        <td colSpan={12}>
                                                            <button type="button" className='button' onClick={() => addMoreSectionThreeLifeInsurance({ insurance_company_name: '', insured_person_name: '', beneficiary_name: '', term_date: '', term_amount: 0, whole_life_amount: 0, loan_amount: 0 })}>{t('button.addRow')}</button>
                                                        </td>
                                                    </tr>
                                                        )
                                                    }
                                                    
                                                    <tr className="total-row">
                                                        <td colSpan={9}>{t('label.total')}</td>
                                                        <td colSpan={1}>${parseFloat('' + totalInsuranceTerm).toFixed(2)}</td>
                                                        <td colSpan={1}>${parseFloat('' + totalInsuranceWhole).toFixed(2)}</td>
                                                        <td colSpan={1}>${parseFloat('' + totalInsuranceLoan).toFixed(2)}</td>
                                                    </tr>
                                                </table>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr><td colSpan={12} style={{ height: '20px' }}></td></tr>
                                    <tr>
                                        <td colSpan={12}>
                                            <div className="collapsible-header" onClick={() => { }}>
                                                {t('section.four.title')}
                                            </div>
                                            <div className="collapsible-content" id="collapsible-section-1">
                                                <table className="section-table">
                                                    <tr>
                                                        <td colSpan={3}>{t('section.four.nameOfDebtor.header')}</td>
                                                        <td colSpan={3}>{t('section.four.descriptionPropertyContractLoan.header')}</td>
                                                        <td colSpan={2}>{t('section.four.dueDate.header')}</td>
                                                        <td colSpan={2}>{t('section.four.repaymentTerms.header')}</td>
                                                        <td colSpan={2}>{t('section.four.balanceInDollars.header')}</td>
                                                    </tr>
                                                    {sectionFourReceivableDueFields.map((item: any, index: number) => (
                                                        <tr key={item.id}>
                                                            <td colSpan={3}>
                                                                <input
                                                                    type='text'
                                                                    {...register(`personal_balance_sheet_section_four_receivable_due.${index}.debtor_name`)}
                                                                    placeholder={t("name")}
                                                                />
                                                            </td>
                                                            <td colSpan={3}>
                                                                <input
                                                                    type='text'
                                                                    {...register(`personal_balance_sheet_section_four_receivable_due.${index}.description`)}
                                                                    placeholder={t('description')}
                                                                />
                                                            </td>
                                                            <td colSpan={2}>
                                                                <Controller
                                                                    name={`personal_balance_sheet_section_four_receivable_due.${index}.due_date`}
                                                                    control={control}
                                                                    render={({ field }) => (
                                                                        <>
                                                                            <DatePicker
                                                                                key={8}
                                                                                selected={field.value ? new Date(field.value) : new Date()}
                                                                                onChange={(e: any) => {
                                                                                    field.onChange(moment(e).format('MM/DD/YYYY'));
                                                                                }}
                                                                                className=''
                                                                                dateFormat={'MM/dd/yyyy'}
                                                                                maxDate={new Date()}
                                                                                calendarIconClassname='tex-end'
                                                                                showYearDropdown
                                                                                scrollableYearDropdown
                                                                                yearDropdownItemNumber={40}
                                                                                showMonthDropdown
                                                                            />
                                                                        </>
                                                                    )}
                                                                />
                                                            </td>
                                                            <td colSpan={2}>
                                                                <input
                                                                    type='text'
                                                                    {...register(`personal_balance_sheet_section_four_receivable_due.${index}.repayment_terms`)}
                                                                    placeholder={t('terms')}
                                                                />
                                                            </td>
                                                            <td colSpan={2}>
                                                                <input
                                                                    type='number'
                                                                    {...register(`personal_balance_sheet_section_four_receivable_due.${index}.balance_amount`)}
                                                                    placeholder={t('balance')}

                                                                    onChange={(event) => {
                                                                        const newFields = [...sectionFourReceivableDueFields];
                                                                        newFields[index].balance_amount = parseFloat(event.target.value) || 0;
                                                                        setTotalReceivableDue(sectionFourReceivableDueFields.reduce((acc: number, item: any) => acc + (parseFloat(item.balance_amount) || 0), 0));
                                                                    }}
                                                                />
                                                            </td>
                                                        </tr>
                                                    ))}
                                                    {
                                                        !isEdit && (
                                                            <tr>
                                                        <td colSpan={12}>
                                                            <button type="button" className='button' onClick={() => addMoreSectionFourReceivableDue({ debtor_name: '', description: '', due_date: '', repayment_terms: '', balance_amount: 0 })}>{t('button.addRow')}</button>
                                                        </td>
                                                    </tr>
                                                        )
                                                    }
                                                    
                                                    <tr className="total-row">
                                                        <td colSpan={10}>{t('label.total')}</td>
                                                        <td colSpan={2}>${parseFloat('' + totalReceivableDue).toFixed(2)}</td>
                                                    </tr>
                                                </table>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr><td colSpan={12} style={{ height: '20px' }}></td></tr>
                                    <tr>
                                        <td colSpan={12}>
                                            <div className="collapsible-header" onClick={() => { }}>
                                                {t('section.five.title')}
                                            </div>
                                            <div className="collapsible-content" id="collapsible-section-1">
                                                <table className="section-table">
                                                    <tr>
                                                        <td colSpan={4}>{t('section.five.primaryPropertyAddress.header')}</td>
                                                        <td colSpan={1}>{t('section.five.yearBuilt.header')}</td>
                                                        <td colSpan={1}>{t('section.five.term.header')}</td>
                                                        <td colSpan={1}>{t('section.five.dateDue.header')}</td>
                                                        <td colSpan={1}>{t('section.five.monthlyPaymentInDollars.header')}</td>
                                                        <td colSpan={1}>{t('section.five.purchaseInDollars.header')}</td>
                                                        <td colSpan={1}>{t('section.five.marketValueInDollars.header')}</td>
                                                        <td colSpan={2}>{t('section.five.mortgageBalanceInDollars.header')}</td>
                                                    </tr>
                                                    {sectionFiveRealEstatePrimaryPropertyFields.map((item: any, index: number) => (
                                                        <tr key={item.id}>
                                                            <td colSpan={4}>
                                                                <input
                                                                    type='text'
                                                                    {...register(`personal_balance_sheet_section_five_real_estate_primary_property.${index}.address`)}
                                                                    placeholder={t('address')}
                                                                />
                                                            </td>
                                                            <td colSpan={1}>
                                                                <input
                                                                    type='number'
                                                                    {...register(`personal_balance_sheet_section_five_real_estate_primary_property.${index}.build_date`)}
                                                                    placeholder={t('yearBuilt')}
                                                                />
                                                            </td>
                                                            <td colSpan={1}>
                                                                <input
                                                                    type='text'
                                                                    {...register(`personal_balance_sheet_section_five_real_estate_primary_property.${index}.term`)}
                                                                    placeholder={t('term')}
                                                                />
                                                            </td>
                                                            <td colSpan={1}>
                                                                <Controller
                                                                    name={`personal_balance_sheet_section_five_real_estate_primary_property.${index}.due_date`}
                                                                    control={control}
                                                                    render={({ field }) => (
                                                                        <>
                                                                            <DatePicker
                                                                                key={9}
                                                                                selected={field.value ? new Date(field.value) : new Date()}
                                                                                onChange={(e: any) => {
                                                                                    field.onChange(moment(e).format('MM/DD/YYYY'));
                                                                                }}
                                                                                className=''
                                                                                dateFormat={'MM/dd/yyyy'}
                                                                                maxDate={new Date()}
                                                                                calendarIconClassname='tex-end'
                                                                                showYearDropdown
                                                                                scrollableYearDropdown
                                                                                yearDropdownItemNumber={40}
                                                                                showMonthDropdown
                                                                            />
                                                                        </>
                                                                    )}
                                                                />
                                                            </td>
                                                            <td colSpan={1}>
                                                                <input
                                                                    type='number'
                                                                    {...register(`personal_balance_sheet_section_five_real_estate_primary_property.${index}.monthly_payment_amount`)}
                                                                    placeholder={t('monthlyPayment')}
                                                                />
                                                            </td>
                                                            <td colSpan={1}>
                                                                <input
                                                                    type='number'
                                                                    {...register(`personal_balance_sheet_section_five_real_estate_primary_property.${index}.purchase_amount`)}
                                                                    placeholder={t('purchasePrice')}
                                                                />
                                                            </td>
                                                            <td colSpan={1}>
                                                                <input
                                                                    type='number'
                                                                    {...register(`personal_balance_sheet_section_five_real_estate_primary_property.${index}.market_value_amount`)}
                                                                    placeholder="Market Value"

                                                                    onChange={(event) => {
                                                                        const newFields = [...sectionFiveRealEstatePrimaryPropertyFields];
                                                                        newFields[index].market_value_amount = parseFloat(event.target.value) || 0;
                                                                        setTotalRealEstatePrimaryMrkt(sectionFiveRealEstatePrimaryPropertyFields.reduce((acc: number, item: any) => acc + (parseFloat(item.market_value_amount) || 0), 0));
                                                                    }}
                                                                />
                                                            </td>
                                                            <td colSpan={2}>
                                                                <input
                                                                    type='number'
                                                                    {...register(`personal_balance_sheet_section_five_real_estate_primary_property.${index}.mortgage_balance_amount`)}
                                                                    placeholder="Mortgage Balance"

                                                                    onChange={(event) => {
                                                                        const newFields = [...sectionFiveRealEstatePrimaryPropertyFields];
                                                                        newFields[index].mortgage_balance_amount = parseFloat(event.target.value) || 0;
                                                                        setTotalRealEstatePrimaryMortgage(sectionFiveRealEstatePrimaryPropertyFields.reduce((acc: number, item: any) => acc + (parseFloat(item.mortgage_balance_amount) || 0), 0));
                                                                    }}
                                                                />
                                                            </td>
                                                        </tr>
                                                    ))}
                                                    {
                                                        !isEdit && (
                                                            <tr>
                                                        <td colSpan={12}>
                                                            <button type="button" className='button' onClick={() => addMoreSectionFiveRealEstatePrimaryProperty({ address: '', build_date: '', term: '', due_date: '', monthly_payment_amount: 0, purchase_amount: 0, market_value_amount: 0, mortgage_balance_amount: 0 })}>{t('button.addRow')}</button>
                                                        </td>
                                                    </tr>
                                                        )
                                                    }
                                                    
                                                    <tr className="total-row">
                                                        <td colSpan={9}>{t('section.five.totalPrimary')}</td>
                                                        <td colSpan={1}>${parseFloat('' + totalRealEstatePrimaryMrkt).toFixed(2)}</td>
                                                        <td colSpan={2}>${parseFloat('' + totalRealEstatePrimaryMortgage).toFixed(2)}</td>
                                                    </tr>
                                                    <tr>
                                                        <td colSpan={4}>{t('section.five.otherPropertyAddress.header')}</td>
                                                        <td colSpan={1}>{t('section.five.yearBuilt.header')}</td>
                                                        <td colSpan={1}>{t('section.five.term.header')}</td>
                                                        <td colSpan={1}>{t('section.five.dateDue.header')}</td>
                                                        <td colSpan={1}>{t('section.five.monthlyPaymentInDollars.header')}</td>
                                                        <td colSpan={1}>{t('section.five.purchaseInDollars.header')}</td>
                                                        <td colSpan={1}>{t('section.five.marketValueInDollars.header')}</td>
                                                        <td colSpan={2}>{t('section.five.mortgageBalanceInDollars.header')}</td>
                                                    </tr>
                                                    {sectionFiveRealEstateOtherPropertyFields.map((item: any, index: number) => (
                                                        <tr key={item.id}>
                                                            <td colSpan={4}>
                                                                <input
                                                                    type='text'
                                                                    {...register(`personal_balance_sheet_section_five_real_estate_other_property.${index}.address`)}
                                                                    placeholder={t('address')}
                                                                />
                                                            </td>
                                                            <td colSpan={1}>
                                                                <input
                                                                    type='number'
                                                                    {...register(`personal_balance_sheet_section_five_real_estate_other_property.${index}.build_date`)}
                                                                    placeholder={t('yearBuilt')}
                                                                />
                                                            </td>
                                                            <td colSpan={1}>
                                                                <input
                                                                    type='text'
                                                                    {...register(`personal_balance_sheet_section_five_real_estate_other_property.${index}.term`)}
                                                                    placeholder={t('term')}
                                                                />
                                                            </td>
                                                            <td colSpan={1}>
                                                                <Controller
                                                                    name={`personal_balance_sheet_section_five_real_estate_other_property.${index}.due_date`}
                                                                    control={control}
                                                                    render={({ field }) => (
                                                                        <>
                                                                            <DatePicker
                                                                                key={10}
                                                                                selected={field.value ? new Date(field.value) : new Date()}
                                                                                onChange={(e: any) => {
                                                                                    field.onChange(moment(e).format('MM/DD/YYYY'));
                                                                                }}
                                                                                className=''
                                                                                dateFormat={'MM/dd/yyyy'}
                                                                                maxDate={new Date()}
                                                                                calendarIconClassname='tex-end'
                                                                                showYearDropdown
                                                                                scrollableYearDropdown
                                                                                yearDropdownItemNumber={40}
                                                                                showMonthDropdown
                                                                            />
                                                                        </>
                                                                    )}
                                                                />
                                                            </td>
                                                            <td colSpan={1}>
                                                                <input
                                                                    type='number'
                                                                    {...register(`personal_balance_sheet_section_five_real_estate_other_property.${index}.monthly_payment_amount`)}
                                                                    placeholder={t('monthlyPayment')}
                                                                />
                                                            </td>
                                                            <td colSpan={1}>
                                                                <input
                                                                    type='number'
                                                                    {...register(`personal_balance_sheet_section_five_real_estate_other_property.${index}.purchase_amount`)}
                                                                    placeholder={t('purchasePrice')}
                                                                />
                                                            </td>
                                                            <td colSpan={1}>
                                                                <input
                                                                    type='number'
                                                                    {...register(`personal_balance_sheet_section_five_real_estate_other_property.${index}.market_value_amount`)}
                                                                    placeholder="Market Value"

                                                                    onChange={(event) => {
                                                                        const newFields = [...sectionFiveRealEstateOtherPropertyFields];
                                                                        newFields[index].market_value_amount = parseFloat(event.target.value) || 0;
                                                                        setTotalRealEstateOtherMrkt(sectionFiveRealEstateOtherPropertyFields.reduce((acc: number, item: any) => acc + (parseFloat(item.market_value_amount) || 0), 0));
                                                                    }}
                                                                />
                                                            </td>
                                                            <td colSpan={2}>
                                                                <input
                                                                    type='number'
                                                                    {...register(`personal_balance_sheet_section_five_real_estate_other_property.${index}.mortgage_balance_amount`)}
                                                                    placeholder="Mortgage Balance"
                                                                    onChange={(event) => {
                                                                        const newFields = [...sectionFiveRealEstateOtherPropertyFields];
                                                                        newFields[index].mortgage_balance_amount = parseFloat(event.target.value) || 0;
                                                                        setTotalRealEstateOtherMortgage(sectionFiveRealEstateOtherPropertyFields.reduce((acc: number, item: any) => acc + (parseFloat(item.mortgage_balance_amount) || 0), 0));
                                                                    }}
                                                                />
                                                            </td>
                                                        </tr>
                                                    ))}
                                                    {
                                                        !isEdit && (
                                                            <tr>
                                                        <td colSpan={12}>
                                                            <button type="button" className='button' onClick={() => addMoreSectionFiveRealEstateOtherProperty({ address: '', build_date: 0, term: '', due_date: '', monthly_payment_amount: 0, purchase_amount: 0, market_value_amount: 0, mortgage_balance_amount: 0 })}>{t('button.addRow')}</button>
                                                        </td>
                                                    </tr>
                                                        )
                                                    }
                                                    
                                                    <tr className="total-row">
                                                        <td colSpan={9}>{t('section.five.totalPrimary')}</td>
                                                        <td colSpan={1}>${parseFloat('' + totalRealEstateOtherMrkt).toFixed(2)}</td>
                                                        <td colSpan={2}>${parseFloat('' + totalRealEstateOtherMortgage).toFixed(2)}</td>
                                                    </tr>
                                                </table>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr><td colSpan={12} style={{ height: '20px' }}></td></tr>
                                    <tr>
                                        <td colSpan={12}>
                                            <div className="collapsible-header" onClick={() => { }}>
                                                {t('section.six.title')}
                                            </div>
                                            <div className="collapsible-content" id="collapsible-section-1">
                                                <table className="section-table">
                                                    <tr>
                                                        <td colSpan={3}>{t('section.six.nameOfInstitution.header')}</td>
                                                        <td colSpan={3}>{t('section.six.accountType.header')}</td>
                                                        <td colSpan={2}>{t('section.six.valueInDollars.header')}</td>
                                                        <td colSpan={2}>{t('section.six.vestedInDollars.header')}</td>
                                                        <td colSpan={2}>{t('section.six.loansInDollars.header')}</td>
                                                    </tr>
                                                    {sectionSixProfitSharingFields.map((item: any, index: number) => (
                                                        <tr key={item.id}>
                                                            <td colSpan={3}>
                                                                <input
                                                                    type='text'
                                                                    {...register(`section_six_profit_sharing.${index}.name`)}
                                                                    placeholder={t("name")}
                                                                />
                                                            </td>
                                                            <td colSpan={3}>
                                                                <input
                                                                    type='text'
                                                                    {...register(`section_six_profit_sharing.${index}.account_type`)}
                                                                    placeholder={t('accountType')}
                                                                />
                                                            </td>
                                                            <td colSpan={2}>
                                                                <input
                                                                    type='number'
                                                                    {...register(`section_six_profit_sharing.${index}.value`)}
                                                                    placeholder="Value"

                                                                    onChange={(event) => {
                                                                        const newFields = [...sectionSixProfitSharingFields];
                                                                        newFields[index].value = parseFloat(event.target.value) || 0;
                                                                        setTotalPensionValue(sectionSixProfitSharingFields.reduce((acc: number, item: any) => acc + (parseFloat(item.value) || 0), 0));
                                                                    }}
                                                                />
                                                            </td>
                                                            <td colSpan={2}>
                                                                <input
                                                                    type='number'
                                                                    {...register(`section_six_profit_sharing.${index}.vested`)}
                                                                    placeholder={t('vested')}

                                                                    onChange={(event) => {
                                                                        const newFields = [...sectionSixProfitSharingFields];
                                                                        newFields[index].vested = parseFloat(event.target.value) || 0;
                                                                        setTotalPensionVested(sectionSixProfitSharingFields.reduce((acc: number, item: any) => acc + (parseFloat(item.vested) || 0), 0));
                                                                    }}
                                                                />
                                                            </td>
                                                            <td colSpan={2}>
                                                                <input
                                                                    type='number'
                                                                    {...register(`section_six_profit_sharing.${index}.loans`)}
                                                                    placeholder="Loans"

                                                                    onChange={(event) => {
                                                                        const newFields = [...sectionSixProfitSharingFields];
                                                                        newFields[index].loans = parseFloat(event.target.value) || 0;
                                                                        setTotalPensionLoan(sectionSixProfitSharingFields.reduce((acc: number, item: any) => acc + (parseFloat(item.loans) || 0), 0));
                                                                    }}
                                                                />
                                                            </td>
                                                        </tr>
                                                    ))}
                                                    {
                                                        !isEdit && (
                                                            <tr>
                                                        <td colSpan={12}>
                                                            <button type="button" className='button' onClick={() => addMoreSectionSixProfitSharing({ name: '', account_type: '', value: 0, vested: 0, loans: 0 })}>{t('button.addRow')}</button>
                                                        </td>
                                                    </tr>
                                                        )
                                                    }
                                                    
                                                    <tr className="total-row">
                                                        <td colSpan={6}>{t('label.total')}</td>
                                                        <td colSpan={2}>${parseFloat('' + totalPensionValue).toFixed(2)}</td>
                                                        <td colSpan={2}>${parseFloat('' + totalPensionVested).toFixed(2)}</td>
                                                        <td colSpan={2}>${parseFloat('' + totalPensionLoan).toFixed(2)}</td>
                                                    </tr>
                                                </table>
                                            </div>
                                        </td>
                                    </tr>
                                </table>
                                {/* </div>
                                    <div ref={ref => pagesRefs.current[2] = ref}> */}
                                <table className="personal-balance-sheet main-table" ref={ref => pagesRefs.current[3] = ref}>
                                    <tr><td colSpan={12} style={{ height: '20px' }}></td></tr>
                                    <tr>
                                        <td colSpan={12}>
                                            <div className="collapsible-header" onClick={() => { }}>
                                                {t('section.seven.title')}
                                            </div>
                                            <div className="collapsible-content" id="collapsible-section-1">
                                                <table className="section-table">
                                                    <tr>
                                                        <td colSpan={1}>{t('section.seven.year.header')}</td>
                                                        <td colSpan={2}>{t('section.seven.make.header')}</td>
                                                        <td colSpan={3}>{t('section.seven.model.header')}</td>
                                                        <td colSpan={2}>{t('section.seven.miles.header')}</td>
                                                        <td colSpan={2}>{t('section.seven.loanBalanceInDollars.header')}</td>
                                                        <td colSpan={1}>{t('section.seven.appraisalInDollars.header')}</td>
                                                        <td colSpan={1}>{t('section.seven.valueInDollars.header')}</td>
                                                    </tr>
                                                    {sectionSevenAutomobilesFields.map((item: any, index: number) => (
                                                        <tr key={item.id}>
                                                            <td colSpan={1}>
                                                                <input
                                                                    type='number'
                                                                    {...register(`section_seven_automobiles.${index}.year`)}
                                                                    placeholder={t('year')}
                                                                />
                                                            </td>
                                                            <td colSpan={2}>
                                                                <input
                                                                    type='text'
                                                                    {...register(`section_seven_automobiles.${index}.make`)}
                                                                    placeholder={t('make')}
                                                                />
                                                            </td>
                                                            <td colSpan={3}>
                                                                <input
                                                                    type='text'
                                                                    {...register(`section_seven_automobiles.${index}.model`)}
                                                                    placeholder={t('model')}
                                                                />
                                                            </td>
                                                            <td colSpan={2}>
                                                                <input
                                                                    type='number'
                                                                    {...register(`section_seven_automobiles.${index}.miles`)}
                                                                    placeholder={t('miles')}
                                                                />
                                                            </td>
                                                            <td colSpan={2}>
                                                                <input
                                                                    type='number'
                                                                    {...register(`section_seven_automobiles.${index}.loan_balance`)}
                                                                    placeholder={t('loanBalance')}

                                                                    onChange={(event) => {
                                                                        const newFields = [...sectionSevenAutomobilesFields];
                                                                        newFields[index].loan_balance = parseFloat(event.target.value) || 0;
                                                                        setTotalAutoMobileLoan(sectionSevenAutomobilesFields.reduce((acc: number, item: any) => acc + (parseFloat(item.loan_balance) || 0), 0));
                                                                    }}
                                                                />
                                                            </td>
                                                            <td colSpan={1}>
                                                                <input
                                                                    type='number'
                                                                    {...register(`section_seven_automobiles.${index}.apprisal`)}
                                                                    placeholder={t('appraisal')}

                                                                    onChange={(event) => {
                                                                        const newFields = [...sectionSevenAutomobilesFields];
                                                                        newFields[index].apprisal = parseFloat(event.target.value) || 0;
                                                                        setTotalAutoMobileAppraisal(sectionSevenAutomobilesFields.reduce((acc: number, item: any) => acc + (parseFloat(item.apprisal) || 0), 0));
                                                                    }}
                                                                />
                                                            </td>
                                                            <td colSpan={1}>
                                                                <input
                                                                    type='number'
                                                                    {...register(`section_seven_automobiles.${index}.value`)}
                                                                    placeholder={t('value')}

                                                                    onChange={(event) => {
                                                                        const newFields = [...sectionSevenAutomobilesFields];
                                                                        newFields[index].value = parseFloat(event.target.value) || 0;
                                                                        setTotalAutoMobileValue(sectionSevenAutomobilesFields.reduce((acc: number, item: any) => acc + (parseFloat(item.value) || 0), 0));
                                                                    }}
                                                                />
                                                            </td>
                                                        </tr>
                                                    ))}
                                                    {
                                                        !isEdit && (
                                                            <tr>
                                                        <td colSpan={12}>
                                                            <button type="button" className='button' onClick={() => addMoreSectionSevenAutomobiles({ year: 0, make: '', model: '', miles: '', loan_balance: 0, apprisal: 0, value: 0 })}>{t('button.addRow')}</button>
                                                        </td>
                                                    </tr>
                                                        )
                                                    }
                                                    
                                                    <tr className="total-row">
                                                        <td colSpan={8}>{t('label.total')}</td>
                                                        <td colSpan={2}>${parseFloat('' + totalAutoMobileLoan).toFixed(2)}</td>
                                                        <td colSpan={1}>${parseFloat('' + totalAutoMobileAppraisal).toFixed(2)}</td>
                                                        <td colSpan={1}>${parseFloat('' + totalAutoMobileValue).toFixed(2)}</td>
                                                    </tr>
                                                </table>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr><td colSpan={12} style={{ height: '20px' }}></td></tr>
                                    <tr>
                                        <td colSpan={12}>
                                            <div className="collapsible-header" onClick={() => { }}>
                                                {t('section.eight.title')}
                                            </div>
                                            <div className="collapsible-content" id="collapsible-section-1">
                                                <table className="section-table">
                                                    <tr>
                                                        <td colSpan={4}>{t('section.eight.description.header')}</td>
                                                        <td colSpan={1}>{t('section.eight.insuredYN.header')}</td>
                                                        <td colSpan={2}>{t('section.eight.agentName.header')}</td>
                                                        <td colSpan={2}>{t('section.eight.phone.header')}</td>
                                                        <td colSpan={1}>{t('section.eight.appraisalInDollars')}</td>
                                                        <td colSpan={1}>{t('section.eight.loansInDollars')}</td>
                                                        <td colSpan={1}>{t('section.eight.valueInDollars')}</td>
                                                    </tr>
                                                    {sectionEightPersonalPropertyFields.map((item: any, index: number) => (
                                                        <tr key={item.id}>
                                                            <td colSpan={4}>
                                                                <input
                                                                    type='text'
                                                                    {...register(`section_eight_personal_property.${index}.description`)}
                                                                    placeholder={t('description')}
                                                                />
                                                            </td>
                                                            <td colSpan={1}>
                                                                <input
                                                                    type='text'
                                                                    {...register(`section_eight_personal_property.${index}.insured`)}
                                                                    placeholder={t('insured')}
                                                                />
                                                            </td>
                                                            <td colSpan={2}>
                                                                <input
                                                                    type='text'
                                                                    {...register(`section_eight_personal_property.${index}.agent`)}
                                                                    placeholder={t('agent')}
                                                                />
                                                            </td>
                                                            <td colSpan={2}>
                                                                <input
                                                                    type='number'
                                                                    {...register(`section_eight_personal_property.${index}.phone`)}
                                                                    placeholder={t('phone')}
                                                                />
                                                            </td>
                                                            <td colSpan={1}>
                                                                <input
                                                                    type='number'
                                                                    {...register(`section_eight_personal_property.${index}.apprisal`)}
                                                                    placeholder={t('appraisal')}

                                                                    onChange={(event) => {
                                                                        const newFields = [...sectionEightPersonalPropertyFields];
                                                                        newFields[index].apprisal = parseFloat(event.target.value) || 0;
                                                                        setTotalPropertyAppraisal(sectionEightPersonalPropertyFields.reduce((acc: number, item: any) => acc + (parseFloat(item.apprisal) || 0), 0));
                                                                    }}
                                                                />
                                                            </td>
                                                            <td colSpan={1}>
                                                                <input
                                                                    type='number'
                                                                    {...register(`section_eight_personal_property.${index}.loans`)}
                                                                    placeholder={t('loans')}

                                                                    onChange={(event) => {
                                                                        const newFields = [...sectionEightPersonalPropertyFields];
                                                                        newFields[index].loans = parseFloat(event.target.value) || 0;
                                                                        setTotalPropertyLoan(sectionEightPersonalPropertyFields.reduce((acc: number, item: any) => acc + (parseFloat(item.loans) || 0), 0));
                                                                    }}
                                                                />
                                                            </td>
                                                            <td colSpan={1}>
                                                                <input
                                                                    type='number'
                                                                    {...register(`section_eight_personal_property.${index}.value`)}
                                                                    placeholder={t('value')}

                                                                    onChange={(event) => {
                                                                        const newFields = [...sectionEightPersonalPropertyFields];
                                                                        newFields[index].value = parseFloat(event.target.value) || 0;
                                                                        setTotalPropertyValue(sectionEightPersonalPropertyFields.reduce((acc: number, item: any) => acc + (parseFloat(item.value) || 0), 0));
                                                                    }}
                                                                />
                                                            </td>
                                                        </tr>
                                                    ))}
                                                    {
                                                        !isEdit && (
                                                            <tr>
                                                        <td colSpan={12}>
                                                            <button type="button" className='button' onClick={() => addMoreSectionEightPersonalProperty({ description: '', insured: '', agent: '', phone: '', apprisal: 0, loans: 0, value: 0 })}>{t('button.addRow')}</button>
                                                        </td>
                                                    </tr>
                                                        )
                                                    }
                                                    
                                                    <tr className="total-row">
                                                        <td colSpan={9}>{t('label.total')}</td>
                                                        <td colSpan={1}>${parseFloat('' + totalPropertyAppraisal).toFixed(2)}</td>
                                                        <td colSpan={1}>${parseFloat('' + totalPropertyLoan).toFixed(2)}</td>
                                                        <td colSpan={1}>${parseFloat('' + totalPropertyValue).toFixed(2)}</td>
                                                    </tr>
                                                </table>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr><td colSpan={12} style={{ height: '20px' }}></td></tr>
                                    <tr>
                                        <td colSpan={12}>
                                            <div className="collapsible-header" onClick={() => { }}>
                                                {t('section.nine.title')}
                                            </div>
                                            <div className="collapsible-content" id="collapsible-section-1">
                                                <table className="section-table">
                                                    <tr>
                                                        <td colSpan={7}>{t('section.nine.nameOfCreditorTypeOfAccount.header')}</td>
                                                        <td colSpan={1}>{t('section.nine.dateBorrowed.header')}</td>
                                                        <td colSpan={1}>{t('section.nine.amountBorrowedInDollars.header')}</td>
                                                        <td colSpan={1}>{t('section.nine.dueDate.header')}</td>
                                                        <td colSpan={1}>{t('section.nine.paymentMonthlyInDollars.header')}</td>
                                                        <td colSpan={1}>{t('section.nine.balanceInDollars.header')}</td>
                                                    </tr>
                                                    {sectionNineNotesFields.map((item: any, index: number) => (
                                                        <tr key={item.id}>
                                                            <td colSpan={7}>
                                                                <input
                                                                    type='text'
                                                                    {...register(`section_nine_notes.${index}.name`)}
                                                                    placeholder={t("name")}
                                                                />
                                                            </td>
                                                            <td colSpan={1}>
                                                                <Controller
                                                                    name={`section_nine_notes.${index}.date_borrowed`}
                                                                    control={control}
                                                                    render={({ field }) => (
                                                                        <>
                                                                            <DatePicker
                                                                                key={11}
                                                                                selected={field.value ? new Date(field.value) : new Date()}
                                                                                onChange={(e: any) => {
                                                                                    field.onChange(moment(e).format('MM/DD/YYYY'));
                                                                                }}
                                                                                className=''
                                                                                dateFormat={'MM/dd/yyyy'}
                                                                                maxDate={new Date()}
                                                                                calendarIconClassname='tex-end'
                                                                                showYearDropdown
                                                                                scrollableYearDropdown
                                                                                yearDropdownItemNumber={40}
                                                                                showMonthDropdown
                                                                            />
                                                                        </>
                                                                    )}
                                                                />
                                                            </td>
                                                            <td colSpan={1}>
                                                                <input
                                                                    type='nunber'
                                                                    {...register(`section_nine_notes.${index}.amount_borrowed`)}
                                                                    placeholder={t('amountBorrowed')}
                                                                />
                                                            </td>
                                                            <td colSpan={1}>
                                                                <Controller
                                                                    name={`section_nine_notes.${index}.due_date`}
                                                                    control={control}
                                                                    render={({ field }) => (
                                                                        <>
                                                                            <DatePicker
                                                                                key={12}
                                                                                selected={field.value ? new Date(field.value) : new Date()}
                                                                                onChange={(e: any) => {
                                                                                    field.onChange(moment(e).format('MM/DD/YYYY'));
                                                                                }}
                                                                                className=''
                                                                                dateFormat={'MM/dd/yyyy'}
                                                                                maxDate={new Date()}
                                                                                calendarIconClassname='tex-end'
                                                                                showYearDropdown
                                                                                scrollableYearDropdown
                                                                                yearDropdownItemNumber={40}
                                                                                showMonthDropdown
                                                                            />
                                                                        </>
                                                                    )}
                                                                />
                                                            </td>
                                                            <td colSpan={1}>
                                                                <input
                                                                    type='number'
                                                                    {...register(`section_nine_notes.${index}.payment`)}
                                                                    placeholder={t('payment')}
                                                                />
                                                            </td>
                                                            <td colSpan={1}>
                                                                <input
                                                                    type='number'
                                                                    {...register(`section_nine_notes.${index}.balance`)}
                                                                    placeholder={t('balance')}

                                                                    onChange={(event) => {
                                                                        const newFields = [...sectionNineNotesFields];
                                                                        newFields[index].balance = parseFloat(event.target.value) || 0;
                                                                        setTotalFinancial(sectionNineNotesFields.reduce((acc: number, item: any) => acc + (parseFloat(item.balance) || 0), 0));
                                                                    }}
                                                                />
                                                            </td>
                                                        </tr>
                                                    ))}
                                                    {
                                                        !isEdit && (
                                                            <tr>
                                                        <td colSpan={12}>
                                                            <button type="button" className='button' onClick={() => addMoreSectionNineNotes({ name: '', date_borrowed: '', amount_borrowed: 0, due_date: '', payment: 0, balance: 0 })}>{t('button.addRow')}</button>
                                                        </td>
                                                    </tr>
                                                        )
                                                    }
                                                    
                                                    <tr className="total-row">
                                                        <td colSpan={11}>{t('label.total')}</td>
                                                        <td colSpan={1}>${parseFloat('' + totalFinancial).toFixed(2)}</td>
                                                    </tr>
                                                </table>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr><td colSpan={12} style={{ height: '20px' }}></td></tr>
                                    <tr>
                                        <td colSpan={12}>
                                            <div className="collapsible-header" onClick={() => { }}>
                                                {t('section.nine.other.title')}
                                            </div>
                                            <div className="collapsible-content" id="collapsible-section-1">
                                                <table className="section-table">
                                                    <tr>
                                                        <td colSpan={7}>{t('section.nine.nameOfCreditorTypeOfAccount.header')}</td>
                                                        <td colSpan={1}>{t('section.nine.dateBorrowed.header')}</td>
                                                        <td colSpan={1}>{t('section.nine.amountBorrowedInDollars.header')}</td>
                                                        <td colSpan={1}>{t('section.nine.dueDate.header')}</td>
                                                        <td colSpan={1}>{t('section.nine.paymentMonthlyInDollars.header')}</td>
                                                        <td colSpan={1}>{t('section.nine.balanceInDollars.header')}</td>
                                                    </tr>
                                                    {sectionNineOtherNotesFields.map((item: any, index: number) => (
                                                        <tr key={item.id}>
                                                            <td colSpan={7}>
                                                                <input
                                                                    type='text'
                                                                    {...register(`section_nine_other_notes.${index}.name`)}
                                                                    placeholder={t("name")}
                                                                />
                                                            </td>
                                                            <td colSpan={1}>
                                                                <Controller
                                                                    name={`section_nine_other_notes.${index}.date_borrowed`}
                                                                    control={control}
                                                                    render={({ field }) => (
                                                                        <DatePicker
                                                                            key={13}
                                                                            selected={field.value ? new Date(field.value) : new Date()}
                                                                            onChange={(e: any) => {
                                                                                field.onChange(moment(e).format('MM/DD/YYYY'));
                                                                            }}
                                                                            className=''
                                                                            dateFormat={'MM/dd/yyyy'}
                                                                            maxDate={new Date()}
                                                                            calendarIconClassname='tex-end'
                                                                            showYearDropdown
                                                                            scrollableYearDropdown
                                                                            yearDropdownItemNumber={40}
                                                                            showMonthDropdown
                                                                        />
                                                                    )}
                                                                />
                                                            </td>
                                                            <td colSpan={1}>
                                                                <input
                                                                    type='number'
                                                                    {...register(`section_nine_other_notes.${index}.amount_borrowed`)}
                                                                    placeholder={t('amountBorrowed')}
                                                                />
                                                            </td>
                                                            <td colSpan={1}>
                                                                <Controller
                                                                    name={`section_nine_other_notes.${index}.due_date`}
                                                                    control={control}
                                                                    render={({ field }) => (
                                                                        <DatePicker
                                                                            key={14}
                                                                            selected={field.value ? new Date(field.value) : new Date()}
                                                                            onChange={(e: any) => {
                                                                                field.onChange(moment(e).format('MM/DD/YYYY'));
                                                                            }}
                                                                            className=''
                                                                            dateFormat={'MM/dd/yyyy'}
                                                                            maxDate={new Date()}
                                                                            calendarIconClassname='tex-end'
                                                                            showYearDropdown
                                                                            scrollableYearDropdown
                                                                            yearDropdownItemNumber={40}
                                                                            showMonthDropdown
                                                                        />
                                                                    )}
                                                                />
                                                            </td>
                                                            <td colSpan={1}>
                                                                <input
                                                                    type='number'
                                                                    {...register(`section_nine_other_notes.${index}.payment`)}
                                                                    placeholder={t('payment')}
                                                                />
                                                            </td>
                                                            <td colSpan={1}>
                                                                <input
                                                                    type='number'
                                                                    {...register(`section_nine_other_notes.${index}.balance`)}
                                                                    placeholder={t('balance')}

                                                                    onChange={(event) => {
                                                                        const newFields = [...sectionNineOtherNotesFields];
                                                                        newFields[index].balance = parseFloat(event.target.value) || 0;
                                                                        setTotalLiabilities(sectionNineOtherNotesFields.reduce((acc: number, item: any) => acc + (parseFloat(item.balance) || 0), 0));
                                                                    }}
                                                                />
                                                            </td>
                                                        </tr>
                                                    ))}
                                                    {
                                                        !isEdit && (
                                                            <tr>
                                                        <td colSpan={12}>
                                                            <button type="button" className='button' onClick={() => addMoreSectionNineOtherNotes({ name: '', date_borrowed: '', amount_borrowed: 0, due_date: 0, payment: 0, balance: 0 })}>{t('button.addRow')}</button>
                                                        </td>
                                                    </tr>
                                                        )
                                                    }
                                                    
                                                    <tr className="total-row">
                                                        <td colSpan={11}>{t('label.total')}</td>
                                                        <td colSpan={1}>${parseFloat('' + totalLiabilities).toFixed(2)}</td>
                                                    </tr>
                                                </table>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr><td colSpan={12} style={{ height: '20px' }}></td></tr>
                                    <tr>
                                        <td colSpan={12}>
                                            <div className="collapsible-header" onClick={() => { }}>
                                                {t('section.ten.title')}
                                            </div>
                                            <div className="collapsible-content" id="collapsible-section-1">
                                                <table className="section-table">
                                                    <tr>
                                                        <td colSpan={7}>{t('section.ten.nameOfCreditorPayments.header')}</td>
                                                        <td colSpan={1}>{t('section.ten.highBalanceInDollars.header')}</td>
                                                        <td colSpan={1}>{t('section.ten.startDate.header')}</td>
                                                        <td colSpan={1}>{t('section.ten.endDate.header')}</td>
                                                        <td colSpan={2}>{t('section.ten.monthlyPaymentInDollars.header')}</td>
                                                    </tr>
                                                    {sectionTenFields.map((item: any, index: number) => (
                                                        <tr key={item.id}>
                                                            <td colSpan={7}>
                                                                <input
                                                                    type='text'
                                                                    {...register(`section_ten.${index}.name`)}
                                                                    placeholder={t("name")}
                                                                />
                                                            </td>
                                                            <td colSpan={1}>
                                                                <input
                                                                    type='number'
                                                                    {...register(`section_ten.${index}.high_balance`)}
                                                                    placeholder={t('highBalance')}
                                                                />
                                                            </td>
                                                            <td colSpan={1}>
                                                                <Controller
                                                                    name={`section_ten.${index}.start_date`}
                                                                    control={control}
                                                                    render={({ field }) => (
                                                                        <DatePicker
                                                                            key={15}
                                                                            selected={field.value ? new Date(field.value) : new Date()}
                                                                            onChange={(e: any) => {
                                                                                field.onChange(moment(e).format('MM/DD/YYYY'));
                                                                            }}
                                                                            className=''
                                                                            dateFormat={'MM/dd/yyyy'}
                                                                            maxDate={new Date()}
                                                                            calendarIconClassname='tex-end'
                                                                            showYearDropdown
                                                                            scrollableYearDropdown
                                                                            yearDropdownItemNumber={40}
                                                                            showMonthDropdown
                                                                        />
                                                                    )}
                                                                />
                                                            </td>
                                                            <td colSpan={1}>
                                                                <Controller
                                                                    name={`section_ten.${index}.end_date`}
                                                                    control={control}
                                                                    render={({ field: { value, onChange } }) => (
                                                                        <DatePicker
                                                                            key={16}
                                                                            selected={value ? new Date(value) : new Date()}
                                                                            onChange={(e: any) => {
                                                                                onChange(moment(e).format('MM/DD/YYYY'));
                                                                            }}
                                                                            className=''
                                                                            dateFormat={'MM/dd/yyyy'}
                                                                            maxDate={new Date()}
                                                                            calendarIconClassname='tex-end'
                                                                            showYearDropdown
                                                                            scrollableYearDropdown
                                                                            yearDropdownItemNumber={40}
                                                                            showMonthDropdown
                                                                        />
                                                                    )}
                                                                />
                                                            </td>
                                                            <td colSpan={2}>
                                                                <input
                                                                    type='number'
                                                                    {...register(`section_ten.${index}.payment`)}
                                                                    placeholder={t('payment')}

                                                                    onChange={(event) => {
                                                                        const newFields = [...sectionTenFields];
                                                                        newFields[index].payment = parseFloat(event.target.value) || 0;
                                                                        setTotalSectionTen(sectionTenFields.reduce((acc: number, item: any) => acc + (parseFloat(item.payment) || 0), 0));
                                                                    }}
                                                                />
                                                            </td>
                                                        </tr>
                                                    ))}
                                                    {
                                                        !isEdit && (
                                                            <tr>
                                                        <td colSpan={12}>
                                                            <button type="button" className='button' onClick={() => addMoreSectionTen({ name: '', high_balance: 0, start_date: '', end_date: '', payment: 0 })}>{t('button.addRow')}</button>
                                                        </td>
                                                    </tr>
                                                        )
                                                    }
                                                    
                                                    <tr className="total-row">
                                                        <td colSpan={10}>{t('label.total')}</td>
                                                        <td colSpan={2}>${parseFloat('' + totalSectionTen).toFixed(2)}</td>
                                                    </tr>
                                                </table>
                                            </div>
                                        </td>
                                    </tr>
                                    {/* </div> */}
                                </table>
                            </div>
                            <button type="button" onClick={submitForm} className="btn btn-primary mt-4">
                                {showLoader && (<Spinner animation="border" size="sm" />) || t('button.saveAndGeneratePDF')}
                            </button>
                        </Form>
                    </div>

                </div>
            </div>
        </div>

    )
}

export default PersonalBalanceSheet;